import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
declare var jquery: any;
declare var $: any;
import { GridOptions, Column } from "ag-grid/main";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Globals } from 'app/globals';
import { isUndefined } from 'util';
// import { setTimeout } from 'timers';
import { CoachService, AssessmentAssignmentDto } from 'app/services/coach/CoachService';
import { TemplatesService, EmailTemplateDto, LocalizationsEmailTemplate } from 'app/services/template/TemplatesService';
import { AdminService, RaterTypeDto } from 'app/services/admin/AdminService';
import { RaterTypesForModalComponent } from '../c-rater-types/rater-types-for-modal/rater-types-for-modal.component';
import { RatersService } from 'app/services/rater/RatersService';
import { AssessmentsService } from '../../services/assessment/AssessmentsService';
import { DuplicateEmailsManager } from '../../shared/manager/duplicate-emails-manager';
import { ImportClientsValidatorManager } from '../../shared/manager/import-clients-validator-manager';

@Component({
    selector: 'app-assign-assesments-new-modal',
    templateUrl: './assign-assesments-new-modal.component.html',
    styleUrls: ['./assign-assesments-new-modal.component.scss']
})
export class AssignAssesmentsNewModalComponent implements OnInit {

    @ViewChild('assignAssessmentNew', {static: true}) public modal: ModalDirective;
    @ViewChild('raterTypesForModal', {static: true}) public raterTypesForModal: RaterTypesForModalComponent;

    date1 = this.getTodayDate2();
    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };

    public getTodayDate2() {
        var today: any = new Date();
        var dd: any = today.getDate();

        var mm: any = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
/*        console.log(today);*/

        return today;
    }

    public getMinDateForPicker() {
        var today: any = new Date();
        var dd: any = today.getDate();

        var mm: any = today.getMonth() + 1;
        var yyyy = today.getFullYear();

        if(today.getHours() === 23) {
            dd = Number(dd) + 1;
        }

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        today = yyyy + '-' + mm + '-' + dd;
/*        console.log(today);*/

        return today;
    }

    //page1: boolean = true;
    //page2: boolean = false;
    //page3: boolean = false;

    _next: boolean = false;
    pageIndex = 0;


    clients: any[] = [];
    clientsHeaders: any[];
    gridOptions: GridOptions;
    clientsGridOptions: GridOptions;
    ratersGridOptions: GridOptions;
    gridColumnApi;
    overlayNoRowsTemplate; z
    rowSelection;

    height: number;
    count: number;

    clientIds: number[] = [];
    scheduledDate: string;
    language: any;
    expiresIn: any;

    languages: any[] = [];
    assessmentId: number;
    skeepSelection: boolean;
    clientId: number;
    displayTheAssessmentsTable: boolean = false;

    //assessments: any[] = [];
    assessmentsELIData: any[] = [];
    assessments360Data: any[] = [];

    assessmentsHeaders: any[] = [];

    parent: any;
    customTemplates: boolean = false;

    templates: any = {
        invitation: "",
        reminder: "",
        result: ""
    }

    raterTemplates: any = {
        invitation: "",
        reminder: ""
    }

    invitationTemplates: any[] = [];
    reminderTemplates: any[] = [];
    resultTemplates: any[] = [];

    invitationTemplatesModel: string;
    reminderTemplatesModel: string;
    resultTemplatesModel: string;

    raterInvitations: any[] = [];
    raterReminders: any[] = [];
    raterInvitation: any = 0;
    raterReminder: any = 0;
    amount: number;
    currentAmount: number;
    saving: boolean = false;
    assessmentName: string;

    hours: string[] = [
        "12:00 AM",
        "01:00 AM",
        "02:00 AM",
        "03:00 AM",
        "04:00 AM",
        "05:00 AM",
        "06:00 AM",
        "07:00 AM",
        "08:00 AM",
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
        "03:00 PM",
        "04:00 PM",
        "05:00 PM",
        "06:00 PM",
        "07:00 PM",
        "08:00 PM",
        "09:00 PM",
        "10:00 PM",
        "11:00 PM"
    ];

    gtms: any[] = [
        { text: "My time", value: "myTime" },
        { text: "GMT -11", value: 11 },
        { text: "GMT -10", value: 10 },
        { text: "GMT -9", value: 9 },
        { text: "GMT -8", value: 8 },
        { text: "GMT -7", value: 7 },
        { text: "GMT -6", value: 6 },
        { text: "GMT -5", value: 5 },
        { text: "GMT -4", value: 4 },
        { text: "GMT -3", value: 3 },
        { text: "GMT -2", value: 2 },
        { text: "GMT -1", value: 1 },
        { text: "GMT", value: 0 },
        { text: "GMT +1", value: 1 },
        { text: "GMT +2", value: 2 },
        { text: "GMT +3", value: 3 },
        { text: "GMT +4", value: 4 },
        { text: "GMT +5", value: 5 },
        { text: "GMT +6", value: 6 },
        { text: "GMT +7", value: 7 },
        { text: "GMT +8", value: 8 },
        { text: "GMT +9", value: 9 },
        { text: "GMT +10", value: 10 },
        { text: "GMT +11", value: 11 }
    ];

    selectedHour: string;
    selectedGtmText: string;
    selectedGtmValue: any;

    assessmentsRowSelection;
    selectedAssessment: any[] = [];
    displayHeaders: boolean = true;
    currentSelectedClients: number;
    is360: boolean = false;
    enoughAmount: boolean = true;


    //preview template modal
    templateFields: any[] = [];
    customize: boolean = false;

    public editor;
    public editorContent = ``;
    public editorOptions = { placeholder: "insert content..." };
    htmlBody: string = null;
    body: string;
    subject: string;
    name: any;
    purpose: any;
    userType: any;
    type: any;
    niche: any;
    localizations: any;
    currentTemplateId: number;

    purposes: any[] = [];
    types: any[] =
        [{
            "Name": "Regular",
            "Id": 1
        },
        {
            "Name": "360",
            "Id": 2
        }
        ];
    niches: any[] = [];
    userTypes: any = [];
    scheduleSelected: string = "0";
    currentEditedType: string = "";
    currentgridApi: any;
    currentNode: any;
    selectedClients: any[] = [];
    setTheLastOption: boolean = false;
    enableFilter: boolean = false;
    fileName: string = "";
    blobFile: any = null;
    importFileText: string = null;
    importFileBase64: string = null;

    //filters: string[] = ['Email', 'FirstName', 'LastName'];
    tags = [];
    assessmentsRegularGridApi: any;
    assessments360GridApi: any;
    assessmentsCurrentgridApi: any;

    coachTags: any[] = [];
    coachTagsHeaders: any[];
    coachTagsGridApi;
    selectedCoachTags: any[] = [];

    showCheckBox: boolean;

    ratersHeaders: any[];
    assignmentId: number;
    raters: any[] = [];
    raterGridApi;

    /*new rater*/
    rater = {
        email: "",
        raterType: 0,
        firstName: "",
        lastName: "",
        RaterType: {
            Id: 0,
            Name: ""
        }

    }
    addRaterPageIdx: number = 0;
    raterTypes: any[] = [];
    canDeleteRaters: boolean = false;
    canEdit: boolean = false;
    addedRaters: any[] = [];
    fileLoadedEvent: any;
    csvContent: any;
    importedRaters: any[] = [];
    currentRatertype: any;
    ratersRowSelection;
    importType: number;

    invEma: boolean = false;
    remEma: boolean = false;
    resEma: boolean = false;
    ratInv: boolean = false;
    ratRem: boolean = false;

    relationshipAction: string = "Add";
    rowNodeId: string = "";

    //Definitive variables for RATERS
    editedRaters: any[] = [];
    deletedRaters: any[] = [];

    loading: boolean = true;
    pristineRaters: any[] = [];
    arrActiveCategories: any[] = [];
    noRaters: boolean = false;
    lastRelationshipClicked: number;
    tempId = "tempId";
    counter = 0;
    raterTypesStandartData: string[] = [];
    raterTypesCustomData: string[] = [];
    raterTypesStandartDataHeaders: any[];
    raterTypesCustomDataHeaders: any[];
    raterTypesStandartGridApi;
    raterTypesCustomGridApi;
    isStandard: boolean = true;
    rtgridOptions: GridOptions;
    lastCategory: string = 'categories';
    ratertoDelete: any;
    bulkDeleteCategoryId: any;
    pristineCategories: any[] = [];
    executed: boolean = false;
    categoryMin: number;
    inProgress;

    @ViewChild('entries', {static: true}) entries: ElementRef;
    clientEmail: string = "";
    rname: string = '';
    currentSelectedRelationshipsTab: number = 2;
    action: string;
    currentRaterId: number;
    addNewRelationship: boolean = false;
    selectedClientsCount: number;
    loadingClients: boolean = false;

    constructor(
        public _AdminService: AdminService,
        public _AssessmentsService: AssessmentsService,
        public _CoachService: CoachService,
        private _TemplatesService: TemplatesService,
        private _RatersService: RatersService,
        private toastr: ToastrService,
        private router: Router,
        public _Globals: Globals,
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
        this.ratersRowSelection = "multiple";
        this.assessmentsRowSelection = "single";
    }

    ngOnInit() {
        this.getRaterTypesForCoach(false);
        //this.getLanguages();
        this.getNiches();
        this.getTemplatePurposes();
        this.getUserTypesByTemplateType();

        this.gridOptions = {};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.clientsGridOptions = {};
        this.clientsGridOptions.rowHeight = 45;
        this.clientsGridOptions.headerHeight = 40;

        this.ratersGridOptions = {};
        this.ratersGridOptions.rowHeight = 45;
        this.ratersGridOptions.headerHeight = 40;

        this.rtgridOptions = {};
        this.rtgridOptions.rowHeight = 45;
        this.rtgridOptions.headerHeight = 40;

        this.GetCoachClients();
        this.getTemplateFields();
    }

    addTag(tag: string) {
        let split_tags = tag.split(',');
        for (var i = 0; i < split_tags.length; i++) {
            //tag = tag.replace(" ", "_");
            var exist = this.tags.indexOf(split_tags[i]);
            if (exist != -1) {
                //alert("This Tag is already exist");
                //return;
            } else {
                this.tags.push(split_tags[i]);
                console.log(this.tags);
                $('#newTag').val('');
            }

        }

    }

    //changeCustomTemplateStatus() {
    //    this.customTemplates = !this.customTemplates;
    //    console.log(this.customTemplates);
    //}

    onFocusInput() {
        console.log('onFocusInput');
        setTimeout(() => {
            $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
        }, 100);
    }

    onDateSelect(date: any) {
        this.hourChanged();

        date = new Date(date + 'T00:00:00');

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        console.log("today", today);

        const currentHour = new Date().getHours();

        if (date < today) {
            this.toastr.warning("Please enter a date and time greater than the current date and time.", "ELI");
            this.date1 = this.getTodayDate2();

            this.addNewHour(currentHour, false);
        }else if(date > today) {
            this.addNewHour(0, true);
        }else{
            this.addNewHour(currentHour, false);
        }
    }

    setCurrentMinHour(hour: number = undefined) {
        let currentHour: any;

        if (hour != undefined) {
            currentHour = hour;
        } else {
            currentHour = new Date().getHours();
        }

        currentHour = currentHour + 1;

        let AMorPM = 'PM';
        if (Number(currentHour) < 12) {
            AMorPM = 'AM';

            if (Number(currentHour) === 0) {
                currentHour = 12;
            }
        } else {
            if (Number(currentHour) !== 12) {
                currentHour = currentHour - 12;
            }
        }

        if (currentHour.length == 1) {
            currentHour = "0" + currentHour[0];
        }

        currentHour = currentHour + ":00 " + AMorPM;
        console.log('current min Hour', currentHour);
        $("#assignHour select").val(currentHour).change();
    }

    hourChanged() {
        $('.assignAssessmentsModalradios input:radio[name=schedule]').eq(0).prop('checked', false);
        $('.assignAssessmentsModalradios input:radio[name=schedule]').eq(1).prop('checked', true);
    }

    //disable this method (not in use)
    //getEmailTemplatesByUserByPurpose( purpose: number) {
    //    this._TemplatesService.getEmailTemplatesByUserByPurpose(purpose).subscribe((data: any) => {
    //        console.log('response__GetEmailTemplatesByUserByPurpose', data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            console.log('_data', _data);
    //            var lastIndex = _data.length - 1;

    //            switch (purpose) {
    //                case 1:
    //                    if (_data.length > 0) {
    //                        this.invitationTemplates = _data;

    //                        if (this.setTheLastOption) {
    //                            this.invitationTemplatesModel = _data[lastIndex].Id;
    //                        } else {
    //                            this.invitationTemplatesModel = _data[0].Id;
    //                        }
    //                    }
    //                    break;
    //                case 3:
    //                    if (_data.length > 0) {
    //                        this.reminderTemplates = _data;

    //                        if (this.setTheLastOption) {
    //                            this.reminderTemplatesModel = _data[lastIndex].Id;
    //                        } else {
    //                            this.reminderTemplatesModel = _data[0].Id;
    //                        }
    //                    }
    //                    break;
    //                case 2:
    //                    if (_data.length > 0) {
    //                        this.resultTemplates = _data;

    //                        if (this.setTheLastOption) {
    //                            this.resultTemplatesModel = _data[lastIndex].Id;
    //                        } else {
    //                            this.resultTemplatesModel = _data[0].Id;
    //                        }
    //                    }
    //                    break;
    //            }
    //            this.setTheLastOption = false;

    //            if (this.currentEditedType !== "") {
    //                setTimeout(() => {
    //                    var length = $('#' + this.currentEditedType + ' > option').length;
    //                    $('#' + this.currentEditedType + ' :nth-child(' + length + ')').prop('selected', true);
    //                }, 100);
    //            }
    //        }
    //    });
    //}

    //getEmailTemplatesByUserTypeByPurpose(userType: number, purpose: number) {
    //    this._TemplatesService.getEmailTemplatesByUserTypeByPurpose(userType, purpose).subscribe((data: any) => {
    //        console.log('response__GetEmailTemplatesByUserTypeByPurpose ' + userType + ' ' + purpose, data);
    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            var lastIndex = _data.length - 1;

    //            switch (userType) {
    //                case 3: {
    //                    switch (purpose) {
    //                        case 1:
    //                            if (_data.length > 0) {
    //                                this.invitationTemplates = _data;

    //                                if (this.setTheLastOption) {
    //                                    this.invitationTemplatesModel = _data[lastIndex].Id;
    //                                } else {
    //                                    this.invitationTemplatesModel = _data[0].Id;
    //                                }
    //                            }
    //                            break;
    //                        case 3:
    //                            if (_data.length > 0) {
    //                                this.reminderTemplates = _data;

    //                                if (this.setTheLastOption) {
    //                                    this.reminderTemplatesModel = _data[lastIndex].Id;
    //                                } else {
    //                                    this.reminderTemplatesModel = _data[0].Id;
    //                                }
    //                            }
    //                            break;
    //                        case 2:
    //                            if (_data.length > 0) {
    //                                this.resultTemplates = _data;

    //                                if (this.setTheLastOption) {
    //                                    this.resultTemplatesModel = _data[lastIndex].Id;
    //                                } else {
    //                                    this.resultTemplatesModel = _data[0].Id;
    //                                }
    //                            }
    //                            break;
    //                    }
    //                    break;
    //                }
    //                case 4: {
    //                    switch (purpose) {
    //                        case 1: {
    //                            if (_data.length > 0) {
    //                                this.raterInvitations = _data;

    //                                if (this.raterInvitation == 0) {
    //                                    this.raterInvitation = this.raterInvitations[0].Id;
    //                                    this.raterTemplates.invitation = _data[0];
    //                                }

    //                                if (this.setTheLastOption) {
    //                                    this.raterInvitation = _data[lastIndex].Id;
    //                                } else {
    //                                    this.raterInvitation = _data[0].Id;
    //                                }
    //                            }
    //                            break;
    //                        }

    //                        case 3: {
    //                            if (_data.length > 0) {
    //                                this.raterReminders = _data;

    //                                if (this.raterReminder == 0) {
    //                                    this.raterReminder = this.raterReminders[0].Id;
    //                                    this.raterTemplates.reminder = _data[0];
    //                                }

    //                                if (this.setTheLastOption) {
    //                                    this.raterReminder = _data[lastIndex].Id;
    //                                } else {
    //                                    this.raterReminder = _data[0].Id;
    //                                }
    //                            }
    //                            break;
    //                        }
    //                    }
    //                    break;
    //                }
    //            }
    //            this.setTheLastOption = false;

    //            if (this.currentEditedType !== "") {
    //                setTimeout(() => {
    //                    var length = $('#' + this.currentEditedType + ' > option').length;
    //                    $('#' + this.currentEditedType + ' :nth-child(' + length + ')').prop('selected', true);
    //                }, 100);
    //            }
    //        }
    //    })
    //}

    getEmailTemplatesByUserByUserTypeByPurpose(purpose: number, userType: number) {
        this._TemplatesService.getEmailTemplatesByUserByUserTypeByPurpose(purpose, userType).subscribe((data: any) => {
            console.log('response__getEmailTemplatesByUserByUserTypeByPurpose ' + purpose + userType, data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                var lastIndex = _data.length - 1;

                switch (userType) {
                    case 3: {
                        switch (purpose) {
                            case 1:
                                if (_data.length > 0) {
                                    this.invitationTemplates = _data;

                                    if (this.setTheLastOption) {
                                        this.invitationTemplatesModel = _data[lastIndex].Id;
                                    } else {
                                        this.invitationTemplatesModel = _data[0].Id;
                                    }
                                }
                                break;
                            case 3:
                                if (_data.length > 0) {
                                    this.reminderTemplates = _data;

                                    if (this.setTheLastOption) {
                                        this.reminderTemplatesModel = _data[lastIndex].Id;
                                    } else {
                                        this.reminderTemplatesModel = _data[0].Id;
                                    }
                                }
                                break;
                            case 2:
                                if (_data.length > 0) {
                                    this.resultTemplates = _data;

                                    if (this.setTheLastOption) {
                                        this.resultTemplatesModel = _data[lastIndex].Id;
                                    } else {
                                        this.resultTemplatesModel = _data[0].Id;
                                    }
                                }
                                break;
                        }
                        break;
                    }
                    case 4: {
                        switch (purpose) {
                            case 1: {
                                if (_data.length > 0) {
                                    this.raterInvitations = _data;

                                    //if (this.raterInvitation == 0) {
                                    //    this.raterInvitation = this.raterInvitations[0].Id;
                                    //    this.raterTemplates.invitation = _data[0];
                                    //}

                                    if (this.setTheLastOption) {
                                        this.raterInvitation = _data[lastIndex].Id;
                                    } else {
                                        this.raterInvitation = _data[0].Id;
                                    }
                                }
                                break;
                            }

                            case 3: {
                                if (_data.length > 0) {
                                    this.raterReminders = _data;

                                    //if (this.raterReminder == 0) {
                                    //    this.raterReminder = this.raterReminders[0].Id;
                                    //    this.raterTemplates.reminder = _data[0];
                                    //}

                                    if (this.setTheLastOption) {
                                        this.raterReminder = _data[lastIndex].Id;
                                    } else {
                                        this.raterReminder = _data[0].Id;
                                    }
                                }
                                break;
                            }
                        }
                        break;
                    }
                }
                this.setTheLastOption = false;

                if (this.currentEditedType !== "") {
                    setTimeout(() => {
                        var length = $('#' + this.currentEditedType + ' > option').length;
                        $('#' + this.currentEditedType + ' :nth-child(' + length + ')').prop('selected', true);
                    }, 100);
                }
            }
        });
    }


    getEmailTemplatesByAssessment(assessmentId) {
        this._TemplatesService.getEmailTemplatesByAssessment(assessmentId).subscribe((data: any) => {
            console.log('response_getEmailTemplatesByAssessment', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                _data.forEach((template) => {
                    console.log(template);

                    switch (template.UserType) {
                        case 3:
                            switch (template.Purpose) {
                                case 1:
                                    //invitation
                                    this.templates.invitation = template;
                                    break;

                                case 3:
                                    //reminder
                                    this.templates.reminder = template;
                                    break;

                                case 2:
                                    //result
                                    this.templates.result = template;
                                    break;
                                case 4:
                                    //results available
                                    this.templates.resultsAvailable = template;
                                    break;
                            }
                            break;

                        case 4:
                            switch (template.Purpose) {
                                case 1:
                                    //invitation
                                    this.raterTemplates.invitation = template;
                                    console.log('raterTemplates.invitation', this.raterTemplates.invitation);
                                    break;

                                case 3:
                                    //reminder
                                    this.raterTemplates.reminder = template;
                                    console.log('raterTemplates.reminder', this.raterTemplates.reminder);
                                    break;
                            }
                            break;
                    }

                });

                //this.templates.invitation = _data[0];
                //this.templates.reminder = _data[1];
                //this.templates.result = _data[2];
            }
        });
    }

    getLanguagesforAssignAssessments(assessmentId: number) {
        this._AssessmentsService.getLanguagesForAssignAssessments(assessmentId).subscribe((data: any) => {
            console.log('languages', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_getLanguagesforAssignAssessments', _data);
                this.languages = _data;
            }
        });
    }


    //getLanguages() {
    //    this._AdminService.getLanguages().subscribe((data: any) => {
    //        console.log('languages', data.result);
    //        let result = data.result.Result;

    //        if (result <= -10) {
    //            //this.toastr.warning('Expired token please login again.', 'ELI');
    //            this.router.navigate(['/login']);
    //            this._Globals.deleteAllStorage();
    //            return;
    //        }

    //        let _data = JSON.parse(data.result.Data);
    //        console.log('languages', _data);

    //        this.languages = _data;
    //    });
    //}

    //getCoachAvailableAssessments() {
    //    this._GetCoachAvailableAssessments.GetCoachAvailableAssessments(this._Globals.getUserId()).subscribe(data => {
    //        console.log('response_GetCoachAvailableAssessments', data.result);
    //        this.assessments = data.result;
    //        //this.loading = false;
    //    });
    //}

    getCoachAvailableAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachAvailableAssessmentsByType', _data);

                if (assessmentType === 1) {
                    this.assessmentsELIData = _data;
                } else {
                    this.assessments360Data = _data;
                }
            }
        });
    }

    show(parent: any, skeepSelection: boolean, is360: boolean, amount: number, assessmentName: string, assessmentId: number, clientId: number): void {//if we dont show the clients table we nees to display the unassigned assessments
        this.parent = parent;
        this.amount = amount;
        this.currentAmount = this.amount;
        this.assessmentName = assessmentName;
        this.currentSelectedClients = this.parent.rowCount;
        this.is360 = is360;
        if (!this.is360) {
            this.rowSelection = "multiple";
            this.showCheckBox = true;
        } else {
            this.rowSelection = "single";
            this.showCheckBox = false;
        }

        this.clientsHeaders = this.createHeaders();

        this.assessmentId = assessmentId;
        console.log('assessmentId', this.assessmentId);
        this.getLanguagesforAssignAssessments(this.assessmentId);

        //validate the assessmentId undefined
        if (this.assessmentId == undefined) {
            this.displayTheAssessmentsTable = true;
            if (this.displayTheAssessmentsTable) {
                this.displayHeaders = false;
            }
            //get the assessments ids and initialize the assessments grid
            //this.gridOptions = <GridOptions>{};
            this.gridOptions.rowHeight = 45;
            this.gridOptions.headerHeight = 40;

            this.assessmentsHeaders = this.createAssessmentsHeaders();

            //this.getCoachAvailableAssessments();
            this.getCoachAvailableAssessmentsByType(1);
            this.getCoachAvailableAssessmentsByType(2);
        }

        this.clientId = clientId;
        console.log('clientId', this.clientId);
        //validate the clientId undefined

        this.skeepSelection = skeepSelection;
        console.log('showClientsTable', this.skeepSelection);

        //this.page1 = true;
        //this.page2 = false;
        //this.page3 = false;
        if (!this.skeepSelection) {
            if (this._Globals.assignAssessmentsForImportClients) {
                this.pageIndex = 2;
                this.getEmailTemplates();
                $('.assignAssessmentsModalradios input:radio[name=schedule]').eq(0).prop('checked', true);
            } else {
                this.pageIndex = 0;
            }
        } else {
            console.log('selectedClient', this.parent.gridApi.getSelectedRows());
            if (this.parent.gridApi.getSelectedRows()[0].Is360) {
                this.pageIndex = 1;
            } else {
                this.pageIndex = 2;
            }
            this.pageToShow();
        }
        this.GetCoachClients();
        if (this.currentgridApi != undefined) {
            this.currentgridApi.paginationGoToPage(0);
        } else {
            this.pageIndex = 0;
            this._Globals.assignAssessmentsForImportClients = false;
        }
        setTimeout(() => {
            this.modal.show();
        }, 100);
        //$('.wc-date-container').css({ "border": "1px solid #ccc", "font-size": "14px" });
        $('.wc-date-container span').css("color", "#000");
    }

    onShown(): void {
        console.log("onShow");
        if (!isUndefined(this.assessmentsRegularGridApi)) {
            this.sizeToFit(this.assessmentsRegularGridApi);
        }
        $('#clientsModalGrid .ag-floating-filter-input').eq(0).closest('.ag-header-cell').hide();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);

        //if (this.showClientsTable) {
        //    $('#clientsGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
        //}

        //if (this.clients.length === 0) {
        //    $('#clientsGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
        //}

        //this.gridOptions.suppressRowClickSelection = true;
        //if (this.assessmentsGridApi !== undefined) {
        //    this.sizeToFit(this.assessmentsGridApi);
        //    this.currentgridApi = this.assessmentsGridApi;
        //}

        //if (this.gridApi !== undefined) {
        //    this.sizeToFit(this.gridApi);
        //    this.currentgridApi = this.gridApi;
        //}
    }

    close(closeAssign: boolean): void {
        $('#assessmentTypes li').removeClass('active').eq(0).addClass('active');
        $('.assessmentTabs #assessmentTab2').removeClass('active in');
        $('.assessmentTabs #assessmentTab1').addClass('active in');

        $('.eTemplates li').removeClass('active').eq(0).addClass('active');
        $('.eTemplates div').removeClass('in active').eq(0).addClass('in active');
        this.modal.hide();
        this.scheduleSelected = "0";
        //this.customTemplates = false;
        if (this.currentgridApi != undefined) this.currentgridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
        if (!isUndefined(this.assessmentsRegularGridApi)) {
            this.parent.gridApi.forEachNode(function (node) {
                node.setSelected(false);
            });
        }
        this.selectedAssessment = [];
        this.tags = [];
        this.importedRaters = [];
        this.addedRaters = [];
        this.editedRaters = [];
        this.deletedRaters = [];
        this.raters = [];
        //this.raterGridApi.setRowData([]); 
        this.invEma = false;
        this.remEma = false;
        this.resEma = false;
        this.ratInv = false;
        this.ratRem = false;

        this.arrActiveCategories = [];
        this.pristineCategories = [];
        this.executed = false;
        $('#assignMainAccordion .panel').css('display', 'none');
        $('#purchaseAssessment  .assignAcc div').removeClass('in');
        $('#assignMainAccordion .panel').removeClass('accOpen');
        $('#assignMainAccordion .panel').addClass('accHide');
        $('.panel a').css('color', '#63ceeb');
        $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        this.hideConfirmCloseRatersModal();
        this.noRaters = true;
        $('.panel-collapse').removeClass('collapse, in');
        $('#assignExpiresIn').val(30);
        $('.assignAssessmentsModalradios input:radio[name=schedule]').eq(1).prop('checked', false);
        $('.assignAssessmentsModalradios input:radio[name=schedule]').eq(0).prop('checked', true);
        this.date1 = new Date();
        $('#assignLanguages  option').eq(0).prop('selected', true);

        //this.deselectAllCheckBox(this.gridApi);

        //if (this._Globals.closeHomeAssignModal) {
        //    this.parent.hideAssignModal();
        //    this._Globals.closeHomeAssignModal = false;
        //}

        //pages close actions
        if (this.parent) {
            if (closeAssign) {
                if (this._Globals.assignAssessmentsForImportClients) {
                    this.parent.closeImportModal();
                    this.pageIndex = 0;
                }
            }


            if (this.parent.parent) {
                console.log('PAGE NAME', this.parent.parent.pageName);
                this.parent.close();

                switch (this.parent.parent.pageName) {
                    case "coach_assessments":
                        $('.desktopTabs li').click();
                        break;

                    case "clients":
                        console.log('clients page');
                        break;

                    case "edit_clients":
                        $('.desktopTabs li.active').first().click();
                        break;

                    case "home":
                        break;

                    default:
                        console.log("NO PAGE");
                }
            }
        }
        
        if (closeAssign) this._Globals.assignAssessmentsForImportClients = false;
    }

    prev() {
        if (this.pageIndex == 2 && !this.is360) {
            this.pageIndex -= 2;
        } else {
            this.pageIndex--;
        }
        this.pageToShow();
        //this.customTemplates = false;
        //this.selectedAssessment = [];
        if (!this.displayTheAssessmentsTable) {
            if (this.pageIndex == 0) {
                this.displayHeaders = true;
                //this.currentAmount = this.currentAmount + this.clientIds.length;
            }
        } else {
            if (this.pageIndex == 0) {
                this.displayHeaders = false;
            }
        }

        //if (!isUndefined(this.assessmentsCurrentgridApi)) {
        //    this.assessmentsCurrentgridApi.forEachNode(function (node) {
        //        node.setSelected(false);
        //    });
        //}

        if (this.pageIndex == 1) {
            if (!isUndefined(this.assessmentsRegularGridApi)) {
                setTimeout(() => {
                    this.sizeToFit(this.assessmentsRegularGridApi);
                }, 100);
            }
        }
    }

    next() {
        if (this.pageIndex === 2) {
            var isScheduled = Number($("input[name='schedule']:checked").val()) === 1;        
            if (isScheduled) {
                const dateInputValue = String($("#inputDatePicker").val());
                const hour = $('#assignHour').val();
                // validate scheduled for
                if (isNaN(Date.parse(dateInputValue)) || !hour || String(hour) === '' ) {
                    this.toastr.warning('Please select a valid schedule date and time', 'ELI')
                    $('#inputDatePicker').trigger('focus');
                    return;
                }
            }

             //validate expire in
             const expiresInIsLessThanzero = Number($('#assignExpiresIn').val()) < 0;
             if (expiresInIsLessThanzero || String($('#assignExpiresIn').val()) === '') {
                 this.toastr.warning('Expires In value must be greater or equal to 0.', 'ELI')
                 $('#assignExpiresIn').trigger('focus');
                 return;
             }
        }

        if (this.pageIndex == 0 && !this.is360) {
            this.pageIndex += 2;
            this.pageToShow();
        } else {
            if (this.is360 && this.pageIndex == 1) {
                this.validateRaters();
            } else {
                this.pageIndex++;
                this.pageToShow();
            }
        }
        console.log('next');
    }

    validateRaters() {
        console.log('');

        //validation 
        let requirements = true;
        let missingRatersCategories = [];
        let missingRatersCategoriesIds = [];

        let activeCategories = $('#purchaseAssessment .accOpen');
        if (activeCategories.length == 0) {
            this.toastr.warning('You must enter raters for at least one category', 'ELI')
            return;
        }

        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(/,/g, '');
            missingRatersCategoriesIds.push(parseInt(r));
        }

        missingRatersCategoriesIds.forEach((item) => {
            let relationshipIndex = this.raterTypes.findIndex(x => x.Id === item);
            if (relationshipIndex != -1) {

                let relationshipsEntries = this.raters.filter((r) => { if (r.RelationshipId === item) return r });

                if (relationshipsEntries.length < this.raterTypes[relationshipIndex].Min) {
                    requirements = false;
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', 'red');
                    missingRatersCategories.push(' ' + this.raterTypes[relationshipIndex].Name);
                } else {
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', '#63ceeb');
                }
            }
        });
        let unic = this.removeDuplicates(missingRatersCategories);

        if (!requirements) {
            this.toastr.warning(`You have not entered the minimum raters required for the following categories: ${unic.join()}`, 'ELI');
            return;
        }

        let raters = this.raters.filter((r) => {
            if ('RecordStatus' in r) return r;
        });
        console.log("raters", raters);

        let missingData = false;
        raters.forEach((item) => {
            if (item.Email === "" || item.FirstName === "" || item.LastName === "") {
                missingData = true;
            }
        });

        if (missingData) {
            this.toastr.warning('Please complete all of the fields for the entered raters.', 'ELI');
            return;
        };

        //console.log('this.addedRaters', this.addedRaters); 
        //var uniqueArray = [];
        //$.each(this.addedRaters, function (i, el) {
        //    if ($.inArray(el.RaterType, uniqueArray) === -1) uniqueArray.push(el.RaterType);
        //});
        //let addedRaters = uniqueArray.join();
        //console.log('uniqueArray', addedRaters);

        //this._RatersService.getCheckRatersTypesMinimum(addedRaters).subscribe((data: any) => {
        //    console.log('response_getCheckRatersTypesMinimum', data);
        //    if (this._Globals.validationToken(data.result.Result)) {
        //        let _data = JSON.parse(data.result.Data);
        //        console.log('_data', _data);
        //        if (_data) {
        //            this.pageIndex++;
        //            this.pageToShow();
        //        } else {
        //            this.toastr.warning("You need to enter 3 rater minimum except for Manager and Direct Report categories", "ELI");
        //        }
        //    }
        //});
        this.addedRaters = this.raters;
        console.log('this.addedRaters', this.addedRaters);
        setTimeout(() => {
            $("#purchaseAssessment input[type=radio]").eq(0).prop("checked", true);
        }, 100);
        this.pageIndex++;
        this.pageToShow();
    }

    validateSelectedClients(selectedClients) {
        this.clientIds = [];
        selectedClients.forEach((client) => {
            console.log(client);
            this.clientIds.push(client.ClientId);
        });
        console.log(this.clientIds);

        if (this.clientIds.length == 0) {
            this.toastr.warning('Please select the clients to assign the assessment to.', 'ELI');
            if (!this.is360) {
                this.pageIndex -= 2;
            } else {
                this.pageIndex--;
            }
            this.pageToShow();
            return;
        }
    }

    addNewHour(minHour: number, customHour: boolean) {
        this.hours = new Array<string>();

        if (minHour === 23) {
            minHour = 0;
        } else {
            if (!customHour) {
                minHour+= 1;
            }
        }

        for (let count = minHour; count < 24; count++) {
            let AMOrPM = 'PM';
            let hour = 0;
            if (count < 12) {
                AMOrPM = 'AM'
                if (count === 0) {
                    hour = 12;
                } else {
                    hour = count;
                }
            } else {
                if (count !== 12) {
                    hour = count - 12;
                } else {
                    hour = 12;
                } 
            }

            let hourAsString = String(hour);
            if (hourAsString.length === 1) {
                hourAsString = '0' + hourAsString
            }

            this.hours.push(hourAsString + ": 00 " + AMOrPM);
        }

        if (customHour) {
            this.setCurrentMinHour(0);
        } else {
            this.setCurrentMinHour();
        }
        //$('#hour').val(currentHour);
    }

    pageToShow() {

        if (this.pageIndex == 2 || this.pageIndex == 1) {
            console.log('page 2');


            if (this.is360 && this.pageIndex == 2) {
                console.log("");
            } else {
                $('.assignAssessmentsModalradios input:radio[name=schedule]').eq(0).prop('checked', true);

                let selectedClient;
                if (!this.skeepSelection) {
                    selectedClient = this.getSelectedRows(this.currentgridApi);
                } else {
                    selectedClient = this.parent.gridApi.getSelectedRows();
                }

                if (selectedClient.length === 0) {
                    if (!isUndefined(this.assessmentsCurrentgridApi)) {
                        selectedClient = this.getSelectedRows(this.assessmentsCurrentgridApi);
                    }
                }

                if (!this._Globals.assignAssessmentsForImportClients) {
                    if (this.displayTheAssessmentsTable) {
                        if (selectedClient.length == 0) {
                            this.toastr.warning('Please select one assessment to assign.', 'ELI');
                            if (!this.is360) {
                                this.pageIndex -= 2;
                            } else {
                                this.pageIndex--;
                            }
                            this.pageToShow();
                            return;
                        }
                        this.displayHeaders = true;
                        this.assessmentId = selectedClient[0].AssessmentId;
                        this.is360 = selectedClient[0].Is360;
                        console.log('assessmentId', this.assessmentId);
                    }
                    else {
                        this.validateSelectedClients(selectedClient);
                    }
                } 
            }

            setTimeout(() => {
                var time = new Date();
                let currentHour = time.getHours();
                this.addNewHour(currentHour, false);
            }, 100);
        }

        if (this.pageIndex < 3) {
            console.log(this.pageIndex);
            //this.page1 = false;
            //this.page2 = false;
            //this.page3 = false;
            switch (this.pageIndex) {
                case 0:
                    //this.page1 = true;
                    setTimeout(() => {
                        $('#clientsModalGrid .ag-floating-filter-input').eq(0).closest('.ag-header-cell').hide();
                    }, 100);

                    //client assign from coach mode
                    if (this.displayTheAssessmentsTable) {
                        if (this.selectedAssessment.length == 0) {
                            return;
                        }
                        this.displayHeaders = true;
                        this.assessmentName = this.selectedAssessment[0].AssessmentName;
                        //this.currentAmount = this.selectedAssessment[0].Amount - this.currentSelectedClients;


                        this.clientIds = [];
                        console.log(this.parent.rowCountData);
                        this.parent.rowCountData.forEach((client) => {
                            console.log(client);
                            this.clientIds.push(client.ClientId);
                        });
                        console.log(this.clientIds);

                        this.templates.invitation = "";
                        this.templates.reminder = "";
                        this.templates.result = "";
                        this.raterTemplates.invitation = "";
                        this.raterTemplates.reminder = "";
                        this.invEma = false;
                        this.remEma = false;
                        this.resEma = false;
                        this.ratInv = false;
                        this.ratRem = false;
                    }
                    break;
                case 1:
                    //this.page2 = true;

                    //load raters content
                    this.ratersHeaders = this.createRatersHeaders();
                    console.log('case 1');

                    if (this.selectedHour != undefined) {
                        setTimeout(() => {
                            $('#assignHour').val(this.selectedHour);
                            //$('#gtm').val(this.selectedGtmValue);
                            $('#assignLanguages').val(this.languages[0].ShortCode);
                            $('#assignExpiresIn').val(30);
                            $('input:radio[name=schedule]').eq(parseInt(this.scheduleSelected)).prop('checked', true);
                        }, 100);
                    }
                    break;
                case 2:

                    if (!this._Globals.assignAssessmentsForImportClients) {
                        let selectedClients;
                        if (!this.displayTheAssessmentsTable) {
                            selectedClients = this.getSelectedRows(this.currentgridApi);
                        } else {
                            selectedClients = this.parent.rowCountData;
                        }
                        this.validateSelectedClients(selectedClients);
                    }

                    //this.templates = {
                    //    invitation: "",
                    //    reminder: "",
                    //    result: ""
                    //}

                    //this.raterTemplates = {
                    //    invitation: "",
                    //    reminder: ""
                    //}

                    this.getEmailTemplates();

                    console.log("Row Data:", this.addedRaters);

                    break;
            }
        } else {
            return;
        }
    }

    getEmailTemplates() {
        //this.getEmailTemplatesByUserByPurpose(1);
        //this.getEmailTemplatesByUserByPurpose(3);
        //this.getEmailTemplatesByUserByPurpose(2);

        this.getEmailTemplatesByUserByUserTypeByPurpose(1, 3);
        this.getEmailTemplatesByUserByUserTypeByPurpose(3, 3);
        this.getEmailTemplatesByUserByUserTypeByPurpose(2, 3);

        //this.getEmailTemplatesByUserTypeByPurpose(4, 1); // rater invitation
        //  this.getEmailTemplatesByUserTypeByPurpose(4, 3); // rater reminder

        this.getEmailTemplatesByUserByUserTypeByPurpose(1, 4);
        this.getEmailTemplatesByUserByUserTypeByPurpose(3, 4);

        //getting the email templates
        this.getEmailTemplatesByAssessment(this.assessmentId);

        setTimeout(() => {
            var time = new Date();
            let currentHour: any = time.getHours();
            this.addNewHour(currentHour, false);
        }, 100);
    }

    //GetCoachClients() {
    //    this._GetCoachClients.GetCoachClients().subscribe(data => {
    //        console.log('response_GetCoachClients', data.result);
    //        this.clients = data.result;
    //    });
    //}

    GetCoachClients() {
        this.loadingClients = true;
        this._CoachService.getCoachClients().subscribe((data: any) => {
            console.log('response_GetCoachClients', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.clients = _data;
                this.loadingClients = false;
            }
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    assessmentsOnGridReady(grid, params) {
        if (grid === 1) {
            this.assessmentsRegularGridApi = params.api;
        } else {
            this.assessments360GridApi = params.api;
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onGridReady(params) {
        this.currentgridApi = params.api;
        console.log('onGridReady CURRENT GRID API', this.currentgridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }


    createHeaders() {
        let columnDefs = new Array();

        let emptyHeader = {
            headerName: '',
            field: '',
            headerCheckboxSelection: this.showCheckBox,
            headerCheckboxSelectionFilteredOnly: this.showCheckBox,
            checkboxSelection: this.showCheckBox,
            minWidth: 30,
            width: 30,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emptyHeader);

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            //headerCheckboxSelection: true,
            //headerCheckboxSelectionFilteredOnly: true,
            //checkboxSelection: true,
            minWidth: 250,
            width: 250,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
                //return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let nameHeader = {
            headerName: 'First Name',
            field: 'FirstName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let lastNameHeader = {
            headerName: 'Last Name',
            field: 'LastName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(lastNameHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        this.currentNode = e.node;

        if (e.event.target !== undefined) {
            let data = e.data;
            switch (e.event.target.id) {
                case "person":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.edit(data['Id'], data['Text']);
                        break;
                    }

                case "deleteAction":
                    {
                        //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
                        this.delete();
                        break;
                    }
            }
        }
    }

    public onAssessessmentRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;

            console.log("clients", this.parent.rowCountData.length);
            console.log("assessment amount", data.Amount);

            if (this.parent.rowCountData.length > data.Amount) {
                this.enoughAmount = false;
                this.toastr.warning("You don't have enough assessments to assign to the selected clients.", "ELI");
            } else if (!this.enoughAmount) {
                this.enoughAmount = true;
            }
        }
    }

    edit(id: number, text: string) {
        console.log('edit');
        //this.openModal('edit', id, text);
    }

    delete() {
        console.log('delete');
    }

    getSelectedRows(gridApi): any {
        return gridApi.getSelectedRows();
    }

    confirmationSave() {
        if (this.invEma) {
            if (isUndefined(this.invitationTemplatesModel)) {
                this.toastr.warning('We are sorry. You have not indicated one or more custom email templates to use.', 'ELI');
                return;
            }
        }

        if (this.remEma) {
            if (isUndefined(this.reminderTemplatesModel)) {
                this.toastr.warning('We are sorry. You have not indicated one or more custom email templates to use.', 'ELI');
                return;
            }
        }

        if (this.resEma) {
            if (isUndefined(this.resultTemplatesModel)) {
                this.toastr.warning('We are sorry. You have not indicated one or more custom email templates to use.', 'ELI');
                return;
            }
        }


        if (this.is360) {
            if (this.ratInv) {
                if (this.raterInvitation == 0) {
                    this.toastr.warning('We are sorry. You have not indicated one or more custom email templates to use.', 'ELI');
                    return;
                }
            }

            if (this.ratRem) {
                if (this.raterReminder == 0) {
                    this.toastr.warning('We are sorry. You have not indicated one or more custom email templates to use.', 'ELI');
                    return;
                }
            }
        }

        console.log('display confirmation popup modal');
        this.showConfirmationSaveModal();
        return;
        //} else {
        //    this.saveAssessmentAssignment();
        //}
    }

    confirmationDenied() {
        //this.processfinished(); 
        this.closeConfirmationSaveModal();
    }

    saveAssessmentAssignment() {
        if (this.clientIds.length == 0) {
            this.clientIds.push(this.clientId);
        }

        if (this.saving) {
            return;
        }

        this.saving = true;
        $('body').css('cursor', 'wait');

        this.selectedHour = $('#assignHour').val();

        this.scheduleSelected = $("input[name='schedule']:checked").val();

        let assessmentAssignment = new AssessmentAssignmentDto;
        assessmentAssignment.CoachId = this._Globals.getUserId();
        assessmentAssignment.AssessmentId = this.assessmentId;
        assessmentAssignment.Language = $('#assignLanguages').val();

        var d = new Date();
        var n = d.getTimezoneOffset();
        this.selectedGtmValue = (n / 60);
        assessmentAssignment.TimeOffset = this.selectedGtmValue;

        let expiresIn = $('#assignExpiresIn').val();
        if (expiresIn > 30) expiresIn = 30;
        assessmentAssignment.ExpiresIn = expiresIn;

        if (this.scheduleSelected === "0") {
            assessmentAssignment.SendNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            assessmentAssignment.ScheduledDate = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.getHours();
            let AMOrPM = 'PM'
            if (Number(currentHour) < 12) {
                AMOrPM = 'AM';
                if (Number(currentHour) === 0) {
                    currentHour = 12;
                }
            } else {
                if (Number(currentHour) !== 12) {
                    currentHour = currentHour - 12;
                }
            }

            if (String(currentHour).length === 1) {
                currentHour = "0" + currentHour;
            }

            assessmentAssignment.ScheduledTime = currentHour + ":00 " + AMOrPM;
        } else {
            assessmentAssignment.SendNow = false;

            this.scheduledDate = this.getFormatDate($('#inputDatePicker').val());

/*            this.scheduledDate = $('.assignAssessmentsModalradios .wc-date-container span').text();*/
/*            this.scheduledDate = this.scheduledDate.slice(0, 10);*/
            //let tempDate = this.scheduledDate.split(" ");
            //this.scheduledDate = tempDate[0];
/*            this.scheduledDate = this.scheduledDate.replace(/-/g, "/");*/
            console.log('scheduledFor', this.scheduledDate);

            assessmentAssignment.ScheduledDate = this.scheduledDate;

            assessmentAssignment.ScheduledTime = $('#assignHour').val();
        }

        assessmentAssignment.ClientIds = this.clientIds;
        assessmentAssignment.UseCustomEmailTemplates = true;

        let emailTemplates = [];
        let allSelected: boolean = true;

        //EMAIL INVITATION
        if (!this.invEma) {
            console.log(this.templates.invitation);
            let templateId = $('.invEma').attr('id');
            emailTemplates.push({
                "TemplateId": parseInt(templateId),
                "Purpose": this.templates.invitation.Purpose,
                "UserType": this.templates.invitation.UserType
            });
        } else {
            console.log(this.invitationTemplates);
            let i = $("#clientInvitation").prop('selectedIndex');
            emailTemplates.push({
                "TemplateId": this.invitationTemplatesModel,
                "Purpose": this.invitationTemplates[i].PurposeId,
                "UserType": this.invitationTemplates[i].UserType
            })
        }

        //EMAIL REMAINDER
        if (!this.remEma) {
            console.log(this.templates.reminder);
            let templateId = $('.remEma').attr('id');
            emailTemplates.push({
                "TemplateId": parseInt(templateId),
                "Purpose": this.templates.reminder.Purpose,
                "UserType": this.templates.reminder.UserType
            });
        } else {
            console.log(this.reminderTemplates);
            let i = $("#clientReminder").prop('selectedIndex');
            emailTemplates.push({
                "TemplateId": this.reminderTemplatesModel,
                "Purpose": this.reminderTemplates[i].PurposeId,
                "UserType": this.reminderTemplates[i].UserType
            })
        }

        //EMAIL RESULT
        if (!this.resEma) {
            console.log(this.templates.result);
            let templateId = $('.resEma').attr('id');
            emailTemplates.push({
                "TemplateId": parseInt(templateId),
                "Purpose": this.templates.result.Purpose,
                "UserType": this.templates.result.UserType
            });
        } else {
            console.log(this.resultTemplates);
            let i = $("#clientResult").prop('selectedIndex');
            emailTemplates.push({
                "TemplateId": this.resultTemplatesModel,
                "Purpose": this.resultTemplates[i].PurposeId,
                "UserType": this.resultTemplates[i].UserType
            })
        }

        if (this.is360) {
            //360 RATER INVITATION
            if (!this.ratInv) {
                console.log(this.raterTemplates.invitation);
                let templateId = $('.ratInv').attr('id');
                emailTemplates.push({
                    "TemplateId": parseInt(templateId),
                    "Purpose": this.raterTemplates.invitation.Purpose,
                    "UserType": this.raterTemplates.invitation.UserType
                });
            } else {
                console.log(this.raterInvitations);
                let i = $("#raterInvitation").prop('selectedIndex');
                emailTemplates.push({
                    "TemplateId": this.raterInvitation,
                    "Purpose": this.raterInvitations[i].PurposeId,
                    "UserType": this.raterInvitations[i].UserType
                })
            }

            //360 RATER REMINDER
            if (!this.ratRem) {
                console.log(this.raterTemplates.reminder);
                let templateId = $('.ratRem').attr('id');
                emailTemplates.push({
                    "TemplateId": parseInt(templateId),
                    "Purpose": this.raterTemplates.reminder.Purpose,
                    "UserType": this.raterTemplates.reminder.UserType
                });
            } else {
                console.log(this.raterReminders);
                let i = $("#raterReminder").prop('selectedIndex');
                emailTemplates.push({
                    "TemplateId": this.raterReminder,
                    "Purpose": this.raterReminders[i].PurposeId,
                    "UserType": this.raterReminders[i].UserType
                })
            }
        }


        //emailTemplates = [
        //    { "TemplateId": this.invitationTemplatesModel, "Purpose": 1, "UserType": 3 },
        //    { "TemplateId": this.resultTemplatesModel, "Purpose": 2, "UserType": 3 },
        //    { "TemplateId": this.reminderTemplatesModel, "Purpose": 3, "UserType": 3 },
        //    { "TemplateId": this.raterInvitation, "Purpose": 1, "UserType": 4 },
        //    { "TemplateId": this.raterReminder, "Purpose": 3, "UserType": 4 }
        //];

        emailTemplates.forEach((item) => {
            if (isUndefined(item.TemplateId)) {
                this.toastr.warning("Please select a value for all of the email template types.", "ELI");
                $('body').css('cursor', 'default');
                this.saving = false;
                allSelected = false;
            }
        });

        if (!allSelected) return;

        assessmentAssignment.EmailTemplates = emailTemplates;

        let tags = [];
        this.tags.forEach((tag) => {
            tags.push(tag.value);
        });
        assessmentAssignment.Tags = tags;

        let raters = [];
        if (this.addedRaters.length > 0) {
            this.addedRaters.forEach(item => {
                delete item.RaterTypeName;
                delete item.tempIdCounter;
                item.ClientId = this._Globals.getUserId();
                item.RaterType = item.RelationshipId;
                raters.push(item);
            });
        }

        assessmentAssignment.Raters = raters;

        let metaData = [];
        metaData.push({
            AssignmentId: 0,
            MetaKey: "TIME_OFFSET",
            MetaValue: this.selectedGtmValue
        });
        assessmentAssignment.MetaData = metaData;

        //this.saving = false;
        console.log(JSON.stringify(assessmentAssignment));

        console.log("assessmentAssignment", assessmentAssignment);

        if (!this._Globals.assignAssessmentsForImportClients) {

            this._CoachService.postSaveAssessmentAssignment(assessmentAssignment).subscribe((data: any) =>
            {
                console.log('response__SaveAssessmentAssignment', data.result);
                if (data.result.Result === 1) {
                    let message360 = "";
                    if (this.is360) {
                        message360 = " All invitation emails for the client and raters have been sent.";
                    }

                    if (this.selectedClientsCount >= 25) {
                        this.toastr.success('Assessments are being assigned in background. You will receive an email when all of them have been processed.', 'ELI');
                    } else {
                        this.toastr.success('Assessment assigned successfully.' + message360, 'ELI');
                    }

                    this.processfinished();

                } else if (data.result.Result == -1) {
                    this.toastr.error('We are sorry.  We cannot create the assign assessment for the selected clients since at least one of the selected Email Templates does not have a version available for the selected Language', 'ELI');
                } else {
                    this.toastr.error('We are sorry.An error happened while trying to assign the assessment to the selected clients', 'ELI');
                }

                this.closeModals();
                $('body').css('cursor', 'default');
                this.saving = false;
            },
                (error: any) => {
                    console.log("ERROR", error);
                    this._Globals._Toastr.error("We are sorry.  An error happened when communicating with the ELI server.", "ELI");
                    //localStorage.setItem("ELIResponseError", "1");

                    const data = {
                        'he3': isNaN(this._Globals.getUserId()) ? 0 : this._Globals.getUserId(),
                        'bo7': error.url,
                        'pm5': "Http Error: " + error.status,
                        'my6': JSON.stringify(assessmentAssignment) + ", " + ',' + error._body + ", " + encodeURIComponent(window.navigator.userAgent)
                    }

                    ////this._Globals.clearAllAndRediretToLogin();

                    this._Globals.postSaveAtLog(this._Globals._CryptoJs.encrypt(JSON.stringify(data), '7s6v9y$B&E)M@MxQfTjWnZq4t7x@z%C*')).subscribe((_data: any) => {
                        console.log('response_postSaveAtLog', _data);
                        this._Globals.validationToken(_data.result.Result);
                    });

                    this.saving = false;
                    this.closeConfirmationSaveModal();
                    $('body').css('cursor', 'default');
                });
            
        } else {
            this._CoachService.postImportAndAssignClients(assessmentAssignment, this._Globals.base64ImportFile).subscribe(data => {
                console.log('response_postImportAndAssignClients', data.result);

                switch (data.result.Result) {
                    case -5:
                        this.toastr.error("We are sorry. The specified file does not include any valid client. Please check that the First Names and Last Names values only include alphanumeric characters and that the the email addresses are valid.", "ELI");
                        break;

                    case -3:
                        this.toastr.error("Invalid file format. Please be sure that you included the 'Email', 'First Name' and 'Last Name' columns. Please notice that headers names are case sensitive.", "ELI");
                        break;

                    case -2:
                        this.toastr.error("We are sorry. You don't have enough available assessments for the number of clients included in the file.", "ELI");
                        break;

                    case -1:
                        this.toastr.warning('We are sorry.  We cannot create the assign assessment for the selected clients since at least one of the selected Email Templates does not have a version available for the selected Language.', 'ELI');
                        break;

                    case 0:
                        this.toastr.error("We are sorry. An unexpected error happened while trying to import the clients.", "ELI");
                        break;

                    case -4:
                    case 1:
                        this.toastr.success("Clients are being imported in background. You will receive an email message with the import results once it is finished.", "ELI");
                        this.processfinished();
                        break;

                    default:
                        this.toastr.error('We are sorry.An error happened while trying to assign the assessment to the selected clients.', 'ELI');

                }

                this.closeModals();
                $('body').css('cursor', 'default');
                this.saving = false;
            });
        }
    }

    getFormatDate(date:string) {
        var originalDate = date;

        var parts = originalDate.split("-");
        var y = parseInt(parts[0]);
        var m = parseInt(parts[1]);
        var d = parseInt(parts[2]);

        // Crear un nuevo objeto Date con los componentes
        var parseDate = new Date(y, m - 1, d);

        var month = parseDate.getMonth() + 1;
        var day = parseDate.getDate();
        var year = parseDate.getFullYear();

        // format date as como mm-dd-yyyy
        var dateFormated = (month < 10 ? '0' : '') + month + '/' + (day < 10 ? '0' : '') + day + '/' + year;

        console.log("getFormatDate", dateFormated);
        return dateFormated;

    }

    closeModals() {
        this.close(true);
        this.closeConfirmationSaveModal();
    }

    processfinished() {
        if (!this._Globals.assignAssessmentsForImportClients) {
            this.removeFilters(this.currentgridApi);
        }

        if (!this.displayTheAssessmentsTable) {
            //this.parent.getCoachAvailableAssessments();
            this.parent.getCoachAvailableAssessmentsByType(1);
            this.parent.getCoachAvailableAssessmentsByType(2);
        } else {

            console.log('parent class Name ', this.parent.className);
            if (this.parent.className == "EditClientComponent") {

                if (this.parent.currentSelectedTab == 0 || this.parent.currentSelectedTab == 0.1) {
                    this.parent.getCoachAvailableAssessmentsByType(1);
                }

                if (this.parent.currentSelectedTab == 0.2) {
                    this.parent.getCoachAvailableAssessmentsByType(2);
                }
            } else {
                this.parent.deselectAllCheckBox();
            }
        }
    }

    /*------------------confirmation modal--------------------*/

    showConfirmationSaveModal() {
        $("#confirmationModal").modal({ backdrop: "static" });
        $('#confirmationModal').modal('show');
    }

    closeConfirmationSaveModal() {
        $('#confirmationModal').modal('hide');
    }

    /*------------------assessments Grid--------------------*/

    createAssessmentsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'AssessmentName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        let version = params.data['MajorVersion'] + "." + params.data['MinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Amount',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(quantityHeader);

        return columnDefs;
    }

    public assessmentsOnRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            //switch (e.event.target.id) {
            //    case "assingAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            //this.edit(data['Id'], data['Text']);
            //            //this.openAssignAssessmentModal(data['AssessmentId']);
            //            break;
            //        }
            //}
        }
    }

    showAddClientModal() {
        $('#email').val('');
        $('#addClientModal').modal('show');
    }

    addClient(email: string, name: string, last: string) {
        console.log("email", email);
        $('body').css('cursor', 'wait');

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            if (name != "" && last != "") {
                this.saveCoachClient(email, name, last);
            } else {
                this.toastr.warning('Please complete all the fields.', "ELI");
                $('body').css('cursor', 'default');
            }

        } else {
            this.toastr.warning('Please enter a valid email address', "ELI");
            $('body').css('cursor', 'default');
        }
    }

    saveCoachClient(email: string, name: string, last: string) {
        this._CoachService.postSaveCoachClient(email, name, last).subscribe(data => {
            console.log('response_PostSaveCoachClient', data.result);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this.GetCoachClients();
                    this.closeModal();
                    this.toastr.success('Client added successfully', 'ELI');
                    $('body').css('cursor', 'default');
                } else {
                    this.toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                }
            }

        });
    }

    preventSpace(value: string, event: any, id: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $('#' + id + '').val('');
        }
    }

    closeModal() {
        $('#addClientModal').modal('hide');
        $('#name').val('');
        $('#last').val('');
    }

    containsObject(obj, list) {
        var i;
        for (i = 0; i < list.length; i++) {
            if (JSON.stringify(list[i]) === JSON.stringify(obj)) {
                return true;
            }
        }
        return false;
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        let nodes = event.api.getSelectedNodes();
        var rowCount = nodes.length;
        this.selectedClientsCount = rowCount;
        console.log("selection changed, ", rowCount + " rows selected");

        this.currentAmount = this.amount - rowCount;
        if (this.currentAmount < 0) {
            this.enoughAmount = false;
            this.toastr.warning("You don't have enough assessments to assign to the selected clients.", "ELI");

            //var model = event.api.getModel();
            //var rowNode = model.rowsToDisplay[1];
            //this.currentNode.setSelected(false);
            //this.currentgridApi;
            this.currentgridApi.forEachNode((node) => {
                //let contains = this.containsObject(node.data.Id, this.selectedClients);
                let a = this.selectedClients.indexOf(node.data.Id);
                if (a == -1) {
                    node.setSelected(false);
                }
            });

        } else {
            let selectedClients = this.getSelectedRows(this.currentgridApi);
            this.selectedClients = [];
            selectedClients.forEach((item) => {
                console.log(item);
                this.selectedClients.push(item.Id);
            });

            console.log('selectedClients', this.selectedClients);

            if (this.selectedClients.length == 1) {
                this.clientEmail = selectedClients[0].Email;
            }
        }

        if (!this.enoughAmount) {
            this.enoughAmount = true;
        }
    }

    selectedTab(index: number) {
        console.log(index);
        switch (index) {
            case 1:
                this.sizeToFit(this.assessmentsRegularGridApi);
                this.deselectAllCheckBox(this.assessments360GridApi);
                this.is360 = false;
                break;
            case 2:
                this.sizeToFit(this.assessments360GridApi);
                this.deselectAllCheckBox(this.assessmentsRegularGridApi);
                this.is360 = true;
                break;
        }
    }

    deselectAllCheckBox(gridApi) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    onAssessmentsSelectionChanged(grid, event) {

        console.log("onSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (grid === 1) {
            this.assessmentsCurrentgridApi = this.assessmentsRegularGridApi;
        } else {
            this.assessmentsCurrentgridApi = this.assessments360GridApi;
        }

        this.selectedAssessment = this.getSelectedRows(this.assessmentsCurrentgridApi);
        console.log("selected Assessment", this.selectedAssessment);

        if (this.displayTheAssessmentsTable && this.enoughAmount) {
            if (this.selectedAssessment.length > 0) {
                this.displayHeaders = true;
                this.assessmentName = this.selectedAssessment[0].AssessmentName;
                this.currentAmount = this.selectedAssessment[0].Amount - this.parent.rowCountData.length;
            }
        } else {
            this.displayHeaders = false;
        }

    }

    /*PREVIEW MODAL*/
    closePreviewModal() {
        $("#previewModal").modal("hide");
        $("#customizable").addClass("displayNone");
        $("#notCustomizable").removeClass("displayNone");
        this.customize = false;
    }

    showPreviewModal(templateId: number, type: string) {
        this.currentEditedType = type;
        console.log("templateId", templateId);
        if (templateId > 0) {
            this.currentTemplateId = templateId;
            this.getEmailTemplate();

        }
    }

    PreviewEmailTemplate() {
        //let currentTemplateId = ;
        let language = $('#assignLanguages').val();

        this._TemplatesService.postPreviewEmailTemplate(this.currentTemplateId, language).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result != 0) {
                    let _data = JSON.parse(data.result.Data);
                    console.log('PreviewEmailTemplate', _data);
                    this.body = _data.Body;
                    this.subject = _data.Subject;

                    $('#subject').val(this.subject);
                    $('#body').html(this.body);
                    $('#previewModal').modal('show');
                } else {
                    this.toastr.error('We are sorry. There are no email template available for the selected language.', 'ELI');
                }

                $('body, .material-icons').css('cursor', 'default');

                //$('#csubject').val(this.subject);
                //this.editorContent = this.body;
            }
        });
    }

    customizeTemplate() {
        this.customize = !this.customize;
        $("#customizable").toggleClass("displayNone");
        $("#notCustomizable").toggleClass("displayNone");
    }

    getTemplateFields() {
        this._AdminService.getTemplateFields().subscribe(data => {
            console.log('response_GetTemplateFields', data.result);
            this.templateFields = data.result;
        });
    }

    onEditorBlured(quill) {
        console.log('editor blur!', quill);
    }

    onEditorFocused(quill) {
        console.log('editor focus!', quill);
    }

    onEditorCreated(quill) {
        this.editor = quill;
        console.log('quill is ready! this is current quill instance object', quill);
    }

    onContentChanged({ quill, html, text }) {
        //console.log('quill content is changed!', quill, html, text);
        this.htmlBody = html;
        console.log('html body', this.htmlBody);
    }

    public options: Object = {
        charCounterCount: true,
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', 'my_dropdown']
    };

    insertCustomFields(fieldName: string) {

        console.log('insertCustomFields');

        var range = this.editor.getSelection();
        if (range) {
            if (range.length == 0) {
                console.log('User cursor is at index', range.index);
            } else {
                var text = this.editor.getText(range.index, range.length);
                console.log('User has highlighted: ', text);
            }
            this.editor.insertText(range.index, `{${fieldName}}`, 'bold', true);

        } else {
            console.log('User cursor is not in editor');

            var length = this.editor.getLength();

            this.editor.insertText(length - 1, `{${fieldName}}`, 'bold', true);
        }
    }

    getEmailTemplate() {
        $('body, .material-icons').css('cursor', 'wait');
        this._TemplatesService.getEmailTemplate(this.currentTemplateId).subscribe((data: any) => {
            //console.log('response_GetEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetEmailTemplate', _data);

                this.name = _data.Name;
                $('#emailTemplateName').val(this.name);
                this.purpose = _data.Purpose;
                this.userType = _data.UserType;
                this.type = _data.AssessmentType;
                this.niche = _data.Niche;
                this.localizations = _data.Localizations;
                this.htmlBody = this.localizations[0].Body;
                this.checkData(this.localizations[0].Language, this.localizations[0].Subject);

                this.PreviewEmailTemplate();
            }
        });
    }

    checkData(languageShortCode: string, subject: string) {

        $('#subject').val('');
        this.editorContent = '';

        //this.clearTextArea();
        console.log('check data', this.localizations);

        //check array for display data in text area if exist
        let exist = false;
        let pos = 0;
        for (var i = 0; i < this.localizations.length; i++) {
            if (languageShortCode == this.localizations[i].Language) {
                exist = true;
                pos = i;
            }
        }
        if (exist) {
            //load html content editor
            //load subject
            $('#csubject').val(this.localizations[pos].Subject);
            this.editorContent = this.localizations[pos].Body;
            console.log('LOCALIZATION VALUES:', this.localizations[pos].Subject, this.localizations[pos].Body);
        }

        $(".panel-body").focus();

    }

    getTemplatePurposes() {
        this._AdminService.getTemplatePurposes().subscribe((data: any) => {
            console.log('response_GetTemplatePurposes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                this.purposes = JSON.parse(data.result.Data);
            }
        });
    }

    getNiches() {
        this._AdminService.getNiches().subscribe((data: any) => {
            console.log('respons_GetNiches', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.niches = _data;
            }
        });
    }

    getUserTypesByTemplateType() {
        this._AdminService.getUserTypesByTemplateType(2).subscribe((data: any) => {
            console.log('response_GetUserTypes', data.result);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                this.userTypes = _data;
            }
        });

    }

    updateEmailTemplate(name: string, type: string, purpose: string, userType: string) {
        console.log('update email template');
        this.saveTemplate(name, type, purpose, "1", userType);
    }

    saveTemplate(name: string, type: string, purpose: string, niche: string, userType: string) {

        if (name == "") {
            this.toastr.warning('Name field empty', "ELI");
            return;
        }


        //adding localization if user not change the select
        let shortCode = $('#alanguages').val();
        let subject = $('#csubject').val();
        this.addLocalization(shortCode, subject);

        let enLocalization = false;

        if (this.localizations.length == 0) {
            this.toastr.warning('No localizations set', "ELI");
            return;
        } else {
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == "en") {
                    enLocalization = true
                }
            }
        }

        if (!enLocalization) {
            this.toastr.warning('English localization missing', 'ELI');
            return;
        }


        let emailTemplate = new EmailTemplateDto();
        emailTemplate.TemplateId = 0;//this.currentTemplateId;
        emailTemplate.Name = name;
        emailTemplate.AssessmentType = parseInt(type);
        emailTemplate.Purpose = parseInt(purpose);
        emailTemplate.UserType = parseInt(userType);
        emailTemplate.Niche = parseInt(niche);
        emailTemplate.Owner = this._Globals.getUserId();
        emailTemplate.Localizations = this.localizations;
        emailTemplate.IsGlobal = false;

        console.log('EMAIL TEMPLATE', emailTemplate);

        this._TemplatesService.postSaveEmailTemplate(emailTemplate).subscribe(data => {
            console.log('response_PostSaveEmailTemplate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this.toastr.success('Email template saved successfully', 'ELI');
                    this.getEmailTemplatesByAssessment(this.assessmentId);
                    this.setTheLastOption = true;

                    switch (this.currentEditedType) {

                        case 'clientInvitation':
                            this.getEmailTemplatesByUserByUserTypeByPurpose(1, 3); //invitancion
                            this.invEma = true;
                            break;
                        case 'clientReminder':
                            this.getEmailTemplatesByUserByUserTypeByPurpose(3, 3); //reminder
                            this.remEma = true;
                            break;
                        case 'clientResult':
                            this.getEmailTemplatesByUserByUserTypeByPurpose(2, 3); //result
                            this.resEma = true;
                            break;
                        case 'raterInvitation':
                            //this.getEmailTemplatesByUserTypeByPurpose(4, 1); // rater invitation
                            this.getEmailTemplatesByUserByUserTypeByPurpose(1, 4);
                            this.ratInv = true;
                            break;
                        case 'raterReminder':
                            //this.getEmailTemplatesByUserTypeByPurpose(4, 3); // rater reminder
                            this.getEmailTemplatesByUserByUserTypeByPurpose(3, 4);
                            this.ratRem = true;
                            break;
                    }

                    //this.customTemplates = true;
                    //$('#checkbox1').prop('checked', true);
                    this.closePreviewModal();
                }

                if (data.result.Result == 0) {
                    this.toastr.error('We are sorry. An error happened while trying to save the email template.', 'ELI');
                }
            }
        });


    }

    addLocalization(shortCode: string, subject: string) {
        //if (text != '') {
        console.log('addLocalization');
        if (subject == "") {
            this.toastr.warning('Subject field empty', 'ELI');
            return;
        }

        if (this.htmlBody == null) {
            this.toastr.warning('Email body empty', 'ELI');
            return;
        }

        if (this.localizations.length == 0) {
            let newLocalization = new LocalizationsEmailTemplate();
            newLocalization.Language = shortCode;
            newLocalization.Subject = subject;
            newLocalization.Body = this.htmlBody;

            this.localizations.push(newLocalization);
        }
        else {

            let addNew = true;
            for (var i = 0; i < this.localizations.length; i++) {
                if (this.localizations[i].Language == shortCode) {
                    //property exist
                    addNew = false;
                    this.localizations[i].Body = this.htmlBody;
                    this.localizations[i].Subject = subject;
                }
            }
            if (addNew) {
                //property not exist
                let newLocalization = new LocalizationsEmailTemplate();
                newLocalization.Language = shortCode;
                newLocalization.Subject = subject;
                newLocalization.Body = this.htmlBody;

                this.localizations.push(newLocalization);
            }
        }
        console.log(this.localizations);
        //}
    }

    //deselectFilter(filterName) {
    //    var filterComponent = this.currentgridApi.getFilterInstance(filterName);
    //    filterComponent.setModel(null);
    //    this.currentgridApi.onFilterChanged();
    //}

    //toggleFilter() {
    //    if (this.enableFilter) {
    //        $('#clientsGrid .ag-body-viewport-wrapper').css({ "margin-top": "-32px", "position": "absolute", "width": "100%", "height": "111%" });
    //        if (this.clients.length === 0) {
    //            $('#clientsGrid .ag-body-viewport.ag-layout-normal').css('background', 'white');
    //        }
    //        console.log('hide filter');
    //        this.filters.forEach((item) => {
    //            this.deselectFilter(item);
    //        });
    //    } else {
    //        $('#clientsGrid .ag-body-viewport-wrapper').css({ "margin-top": "0", "position": "absolute", "width": "100%", "height": "100%" });
    //        if (this.clients.length === 0) {
    //            $('#clientsGrid .ag-body-viewport.ag-layout-normal').css('background', 'transparent');
    //        }
    //        $('.ag-floating-filter-input').eq(0).closest('.ag-header-cell').hide();
    //    }
    //    this.enableFilter = !this.enableFilter;
    //}

    /*Import Modal*/

    showImportModal(type: number) {
        $('#importModal').modal('show');
        this.importType = type;
    }

    closeImportModal() {
        this.clearImportFile();
        $('#importModal').modal('hide');
    }

    clearImportFile() {
        $('#importClientsifile').val('');
        $('#inputFileName').val('');
        this.fileName = "";
        this.blobFile = null;
        this.csvContent = "";
        this.importFileText = null;
        this.importFileBase64 = null;
    }

    // Reads the file when it is selected, so a later change to the file on disk can't break (or hang) the import
    readImportFile(file: any) {
        this.importFileText = null;
        this.importFileBase64 = null;
        if (!file) return;

        const textReader = new FileReader();
        textReader.onload = () => {
            if (this.blobFile === file) this.importFileText = textReader.result as string;
        };
        textReader.onerror = (error) => this.onImportFileReadError(file, error);
        textReader.readAsText(file);

        const base64Reader = new FileReader();
        base64Reader.onload = () => {
            if (this.blobFile === file) this.importFileBase64 = (base64Reader.result as string).split(',')[1];
        };
        base64Reader.onerror = (error) => this.onImportFileReadError(file, error);
        base64Reader.readAsDataURL(file);
    }

    onImportFileReadError(file: any, error: any) {
        console.log('Error: ', error);
        if (this.blobFile !== file) return; // another file was selected meanwhile
        this.toastr.error('We are sorry. The file could not be read. Please select the file again.', 'ELI');
        this.clearImportFile();
    }

    downloadImportClientsTemplate() {
        const name = ImportClientsValidatorManager.templateFileName;
        const data = ImportClientsValidatorManager.templateContent;

        if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(new Blob([data], { type: 'text/csv' }), name);
        }

        const a = $('<a style=\'display: none;\'/>');
        const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
        a.attr('href', url);
        a.attr('download', name);
        $('body').append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    getBlobFile(event: any) {
        console.log(event);
        let file = event.srcElement.value;
        console.log(file);
        let str = String.raw`\fakepath`;
        file = file.split(str);
        file = file[1].substring(1);
        this.fileName = file;

        this.blobFile = event.target.files[0];

        //this.fileLoadedEvent = event;
        //this.onFileSelect(event);
        if (this.importType == 2) {
            this.csv2Array(event);
        } else {
            this.readImportFile(this.blobFile);
        }
    }

    okImportClients() {
        if (this.importType != 2) {
            if (this.blobFile == null) {
                this.toastr.warning("Please select an a .csv file.", "ELI");
            } else if (this.importFileText == null || this.importFileBase64 == null) {
                this.toastr.warning('The file is still loading. Please try again in a moment.', 'ELI');
            } else {
                $('body').css('cursor', 'wait');
                this.processImportFile();
            }
        } else {
            this.importedRaters.forEach(rater => {
                //this.addNewRater(rater, true);
            });

            this.closeImportModal();
        }

    }

    processImportFile() {
        const csvContent = this.importFileText;
        const base64file = this.importFileBase64;

        const errors = ImportClientsValidatorManager.findErrors(csvContent);

        if (errors.length > 0) {
            console.warn('Invalid import file:', errors);
            this.toastr.warning(`The file contains invalid data: \n${errors.slice(0, 5).join('\n')}${errors.length > 5 ? `\n...and ${errors.length - 5} more` : ''}`, 'ELI');
            this.clearImportFile();
            $('body').css('cursor', 'default');
            return; // stop the process
        }

        const duplicates = DuplicateEmailsManager.findDuplicateEmails(csvContent);

        if (duplicates.length > 0) {
            console.warn('Emails duplicados encontrados:', duplicates);
            this.toastr.warning(`We found duplicate emails: \n${duplicates.join(', ')}`, 'ELI');
            this.clearImportFile();
            $('body').css('cursor', 'default');
            return; // stop the process
        }

        console.log("Base64 file", base64file);
        this.importClients(base64file);
    }

    importClients(base64file: string) {
        this._CoachService.postImportClients(base64file).subscribe((data: any) => {
            console.log('response_PostImportClients', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_PostImportClients data', _data);

                switch (data.result.Result) {
                    case -5:
                        this.toastr.error("We are sorry. The specified file does not include any valid client. Please check that the First Names and Last Names values only include alphanumeric characters and that the the email addresses are valid.", "ELI");
                        break;

                    case -4:
                        this.toastr.error("Some clients could not be imported. We sent you an email with the details about the import process.", "ELI");
                        break;

                    case -3:
                        this.toastr.error("Invalid file format. Please be sure that you included the 'Email', 'First Name' and 'Last Name' columns. Please notice that headers names are case sensitive.", "ELI");
                        break;

                    case -2:
                        this.toastr.error("We are sorry. You don't have enough available assessments for the number of clients included in the file.", "ELI");
                        break;

                    case 0:
                        this.toastr.error("We are sorry. An unexpected error happened while trying to import the clients.", "ELI");
                        break;

                    case 1:
                        this.toastr.success("Clients imported successfully.", "ELI");
                        this.GetCoachClients();
                        break;
                }

                this.closeImportModal();
                $('body').css('cursor', 'default');
            }
        });
    }

    csv2Array(fileInput: any) {
        //read file from input
        let fileReaded = fileInput.target.files[0];

        let reader: FileReader = new FileReader();
        reader.readAsText(fileReaded);

        reader.onload = (e) => {
            let csvF: any = reader.result;
            let allTextLines = csvF.split(/\r|\n|\r/);
            let headers = allTextLines[0].split(',');
            let lines = [];

            for (let i = 0; i < allTextLines.length; i++) {
                // split content based on comma
                let data = allTextLines[i].split(',');
                if (data.length === headers.length) {
                    let tarr = [];
                    for (let j = 0; j < headers.length; j++) {
                        tarr.push(data[j]);
                    }

                    // log each row to see output 
                    console.log(tarr);
                    lines.push(tarr);
                }
            }
            // all rows in the csv file 
            console.log(">>>>>>>>>>>>>>>>>", lines);

            lines.forEach(element => {
                let type: any = element[3];

                console.log(typeof type);

                this.checkArr(type);

                this.importedRaters.push({
                    Email: element[0],
                    RaterType: this.currentRatertype,
                    FirstName: element[1],
                    LastName: element[2]
                });

                //this.addNewRater(newRater, true);

            });
        }
    }

    //getCsvEntriesLength(fileInput: any) {
    //    //read file from input
    //    let fileReaded = fileInput.target.files[0];

    //    let reader: FileReader = new FileReader();
    //    reader.readAsText(fileReaded);

    //    reader.onload = (e) => {
    //        let csvF: any = reader.result;
    //        let allTextLines = csvF.split(/\r|\n|\r/);
    //        let headers = allTextLines[0].split(',');
    //        let lines = [];

    //        for (let i = 0; i < allTextLines.length; i++) {
    //            // split content based on comma
    //            let data = allTextLines[i].split(',');
    //            if (data.length === headers.length) {
    //                let tarr = [];
    //                for (let j = 0; j < headers.length; j++) {
    //                    tarr.push(data[j]);
    //                }
    //                console.log(tarr);
    //                if (i != 0) lines.push(tarr);
    //            }
    //        }
    //        console.log(">>>>>>>>>>>>>>>>>", lines);
            
    //    }
    //}

    onFileSelect(input) {
        const files = input.target.files;

        if (files && files.length) {
            const fileToRead = files[0];

            const fileReader = new FileReader();
            //fileReader.onload = this.onFileLoad;
            fileReader.onload = (fileLoadedEvent: any) => {
                const textFromFileLoaded = fileLoadedEvent.target.result;
                this.csvContent = textFromFileLoaded;
                console.log(this.csvContent);

                const csv = [];
                const lines = this.csvContent.split('\n');


                for (let i of lines) {
                    const cols: string[] = i.split(',');
                    csv.push(cols);
                }

                let raterToImport = [];
                lines.forEach(element => {
                    let cols = element.split(',');
                    let type: any = cols[3];
                    console.log(typeof type);

                    if (type.toString() == "Manager") {
                        console.log("THE SAME");
                    } else {
                        console.log("Not THE SAME");
                    }
                    this.checkArr(cols[3]);

                    raterToImport.push({
                        Email: cols[0],
                        RaterType: this.currentRatertype,
                        FirstName: cols[1],
                        LastName: cols[2]
                    });

                });
                console.log(raterToImport);

            };
            fileReader.readAsText(fileToRead, 'base64');
        }
    }

    //onFileLoad(fileLoadedEvent) {
    //    const textFromFileLoaded = fileLoadedEvent.target.result;
    //    let csvContent = textFromFileLoaded;
    //    console.log(csvContent);
    //}

    /*Get Coach Tags*/
    openTagsModal() {
        $("#tagsModalAssignAssessmentsNew").modal({ backdrop: "static" });
        $('#tagsModalAssignAssessmentsNew').modal('show');
        this.coachTagsHeaders = this.createCoachTagsHeaders();
        this.getCoachTags();
        this.sizeToFit(this.coachTagsGridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onCoachTagsGridReady(params) {
        this.coachTagsGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createCoachTagsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Tag',
            field: 'Text',
            minWidth: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);


        return columnDefs;
    }

    onCoachTagsRowClicked(e) {
        console.log(e);
    }

    onCoachTagsSelectionChanged(event: any) {
        console.log("onCoachTagsSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        this.selectedCoachTags = this.getSelectedRows(this.coachTagsGridApi);
        console.log("selectedCoachTags", this.selectedCoachTags);
    }

    getCoachTags() {
        this._CoachService.getCoachTags().subscribe((data: any) => {
            console.log('getCoachTags data', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachTags', _data);
                this.coachTags = _data;
            }
        });
    }

    removeTag(index, text) {
        console.log(index);

        this.selectedCoachTags.splice(index, 1);
        console.log(this.selectedCoachTags);

        this.coachTagsGridApi.forEachNode((node) => {
            console.log(node);
            if (text === node.data.Text) {
                node.setSelected(false);
            }
        });
    }

    addNewCoachTags() {

        this.selectedCoachTags.forEach((item) => {

            let exist = this.tags.find(x => x.value === item.Text);

            if (!exist) {
                this.tags.push({ display: item.Text, value: item.Text });
            }

        });
        this.closeTagsModal();
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    closeTagsModal() {
        $('#tagsModalAssignAssessmentsNew').modal('hide');
        this.selectedCoachTags = [];
    }

    /*Raters*/
    onRaterGridReadyModal(params) {
        this.raterGridApi = params.api;
        this.sizeToFit(this.raterGridApi);
    }

    createRatersHeaders() {
        let columnDefs = new Array();
        //[{
        //    "RaterId": 0,
        //    "Email": "RATER EMAIL",
        //    "AssignedBy": ASSIGNED_BY,
        //    "RaterType": RATER_TYPE,
        //    "FirstName": "FIRST_NAME",
        //    "LastName": "LAST_NAME"
        //}]

        let emailHeader = {
            headerName: 'Email',
            field: 'Email',
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            minWidth: 200,
            width: 255,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        let raterTypeHeader = {
            headerName: 'Relationship',
            field: 'RaterTypeName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(raterTypeHeader);

        let firstNameHeader = {
            headerName: 'First Name',
            field: 'FirstName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(firstNameHeader);

        let lastNameHeader = {
            headerName: 'Last Name',
            field: 'LastName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(lastNameHeader);


        return columnDefs;
    }

    showNewRaterModal(action: string) {
        this.relationshipAction = action;

        if (this.relationshipAction == "Add") {
            this.rater.email = "";
            this.rater.firstName = "";
            this.rater.lastName = "";
            $('#raterTypesSelect option').eq(0).prop('selected', true);
        } else {
            let selectedRaters = this.getSelectedRows(this.raterGridApi);
            console.log(selectedRaters);

            this.rater.email = selectedRaters[0].Email;
            this.rater.firstName = selectedRaters[0].FirstName;
            this.rater.lastName = selectedRaters[0].LastName;
            $('#raterTypesSelect').val(selectedRaters[0].RaterType);
        }

        $("#addModal").modal({ backdrop: "static" });
        $('#addModal').modal('show');
    }

    closeNewRaterModal() {
        $('#addModal').modal('hide');
        console.log('hide');
        this.addRaterPageIdx = 0;
    }

    sameClientEmail(value) {
        console.log('displayTheAssessmentsTable', this.displayTheAssessmentsTable);

        if (this.clientEmail == "") {

            let parentEmail;
            if (this.skeepSelection) {
                parentEmail = this.parent.client.email;
            } else {
                parentEmail = this.parent.gridApi.getSelectedRows()[0].Email;
            }

            if (value == parentEmail) {
                this.toastr.warning("A client cannot be assign her/himself as a rater", "ELI");
                setTimeout(() => {
                    $('#assignMainAccordion').trigger("click");
                }, 100);

                return true;
            } else {
                return false;
            }
        } else {
            if (value == this.clientEmail) {
                this.toastr.warning("A client cannot be assign her/himself as a rater", "ELI");
                setTimeout(() => {
                    $('#assignMainAccordion').trigger("click");
                }, 100);

                return true;
            } else {
                return false;
            }

        }

    }


    validateEmail(email: string, raterPosition: number): boolean {
        if (email !== "") {
            console.log("email", email);

            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let validEmail = regex.test(email);
            console.log('Valid', validEmail)
            if (validEmail) {
                let exist = this.raters.findIndex(x => x.Email === email);
                if (exist != -1 && raterPosition != exist) {
                    this.toastr.warning('The specified Email address is already a rater for this assessment.', "ELI");
                    setTimeout(() => {
                        $('#assignMainAccordion').trigger("click");
                    }, 100);
                    return false;
                } else {
                    return true;
                }
            } else {
                this.toastr.warning('Please enter a valid email address', "ELI");
                setTimeout(() => {
                    $('#assignMainAccordion').trigger("click");
                }, 100);
                return false;
            }
        }
    }


    addRaterNext() {
        this.addRaterPageIdx++;
        console.log(this.addRaterPageIdx);

        if (this.addRaterPageIdx == 1) {
            setTimeout(() => {
                var time = new Date();
                let currentHour: any = time.getHours();
                this.addNewHour(currentHour, false);
                //$('#hour').val(currentHour);
            }, 100);
        }
    }

    addRaterPrev() {
        this.addRaterPageIdx--;
        console.log(this.addRaterPageIdx);
    }

    //getRaterTypesForCoach() {
    //    this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
    //        console.log('response_GetRaterTypesForCoach', data);

    //        if (this._Globals.validationToken(data.result.Result)) {
    //            let _data = JSON.parse(data.result.Data);
    //            console.log('_data', _data);

    //            this.raterTypes = _data;
    //            this.rater.raterType = _data[0].Id;
    //        }
    //    });
    //}

    getRaterTypesForCoachByName(name) {
        //let pos = this.raterTypes.map( (e) => {
        //    return e.Name;
        //}).indexOf(name);
        console.log(name);

        //let pos = -1;
        //for (let i of this.raterTypes) {
        //    if (i.Name == name) return i.Id;
        //}

        return this.raterTypes.find(i => i.Name == name);

        //for (var j = 0; j < this.raterTypes.length; j++) {
        //    if (this.raterTypes[j].Name == name) {
        //        i = j;
        //    }
        //}

        //this.raterTypes.forEach((item, index) => {
        //    if (item.Name == name) {
        //        i = index;
        //        return index;
        //    }
        //});

        //let pos = this.raterTypes.findIndex(x => x.Name === name);

        //if (pos != -1) {
        //    return this.raterTypes[pos].Id;
        //} else {
        //    return 0;
        //}
    }

    checkArr(raterType: string) {
        let currentRatertype = this.raterTypes.find(i => i.Name == raterType);
        if (isUndefined(currentRatertype)) {
            this.currentRatertype = "";
        } else {
            this.currentRatertype = currentRatertype;
        }
        console.log("currentRatertype", this.currentRatertype);
    }

    onRaterRowClicked(e) {
        console.log(e);
    }

    onSelectionChangedForRaters(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount >= 1) {
            this.canDeleteRaters = true;
        } else {
            this.canDeleteRaters = false;
        }

        if (rowCount == 1) {
            this.canEdit = true;
            //getting current row index
            //var size = Object.keys(event.api.selectionController.selectedNodes).length;
            //for (let i = 1; i == size; i++) {
            //    if (event.api.selectionController.selectedNodes[i] !== undefined) {
            //        this.rowNodeId = event.api.selectionController.selectedNodes[i].rowIndex;
            //        console.log(this.rowNodeId);
            //    }
            //}
            let node = this.raterGridApi.getSelectedNodes();
            this.rowNodeId = node[0].rowIndex;
            console.log('getSelectedNodes', this.rowNodeId);
        } else {
            this.canEdit = false;
        }
    }


    //showDeleteRatersConfirmationModal() {
    //    if (this.canDeleteRaters) {
    //        $("#confirmDeleteRatersModal").modal({ backdrop: "static" });
    //        $('#confirmDeleteRatersModal').modal('show');
    //    }
    //}

    //hideDeleteRatersConfirmationModal() {
    //    $('#confirmDeleteRatersModal').modal('hide');
    //}

    //confirmDeleteRaters() {
    //    this.deleteRaters();
    //}

    deleteRaters() {
        let selectedRaters = this.getSelectedRows(this.raterGridApi);
        var res = this.raterGridApi.updateRowData({ remove: selectedRaters });

        this.addedRaters = [];
        this.raterGridApi.forEachNode((node) => {
            this.addedRaters.push(node.data);
        });

        this.hideDeleteRatersConfirmationModal();

        console.log("addedRaters", this.addedRaters);
    }

    /*raterTypesForModal*/
    openRaterTypesForModal() {
        this.raterTypesForModal.show(this, this.parent.modalIndex);
    }


    /*--------------Definitive methods for RATERS---------------*/
    assignRaters() {
        console.log('assignRaters');
    }

    checkRatersAmount() {
        console.log('checkRatersAmount');
        let accOpen = $('#purchaseAssessment .accOpen').length;
        console.log(accOpen);

        if (accOpen == 0) {
            this.noRaters = true;
        } else {
            this.noRaters = false;
        }
    }

    drawData(relationshipId: number, relationshipMin: number, e?) {
        console.log(e);
        //reset all angle icons down
        if (this.lastRelationshipClicked != relationshipId) {
            $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        }

        if (e != undefined) {
            //h4 clicked
            if (e.target.nodeName == 'H4') {
                if (e.target.nextElementSibling.classList.value == 'fas fa-angle-up') {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-up';
                }
            }

            //a clicked
            if (e.target.nodeName == 'DIV') {
                if (e.target.children[1].classList.value == 'fas fa-angle-up') {
                    e.target.children[1].classList.value = 'fas fa-angle-down';
                } else {
                    e.target.children[1].classList.value = 'fas fa-angle-up';
                }
            }

            //i clicked
            if (e.target.nodeName == 'I') {
                if (e.target.classList.value == 'fas fa-angle-up') {
                    e.target.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.classList.value = 'fas fa-angle-up';
                }
            }
        }

        this.lastRelationshipClicked = relationshipId;

        let filteredRaters = this.raters.filter((r) => {
            if (r.RelationshipId === relationshipId) return r;
        });
        console.log('filteredRaters', filteredRaters);

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        $('.assignCategoryEntries').html(``);

        let disabled = 'disabled';
        if (filteredRaters.length > 0) {
            filteredRaters.forEach((item) => {
                let raterId = item.RaterId;
                if (item.tempIdCounter) {
                    disabled = ''
                    raterId = item.tempIdCounter
                }

                let classes = 'd-none d-sm-inline-block btn btn-sm btn-primary sendEntry';
                if (item.tempIdCounter) {
                    classes = 'd-none d-sm-inline-block btn btn-sm btn-gray';
                }
                $('.assignCategoryEntries').append(`
                    <div class="row" data-raterId="${raterId}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;width:25%;min-width:150px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="${item.FirstName}" /></div>
                        <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="${item.LastName}" /></div>
                        <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" ${disabled} type="text" value="${item.Email}" /></div>
                        <div class="dinamicResponsiveA" style="width:20%;">
                            <a _ngcontent-c2="" class="${classes}" style="display:none !important;">
                                <span>Resend Invitation</span>
                                <i _ngcontent-c2="" class="fas fa-paper-plane text-white-50"><span _ngcontent-c2="" class="button-text"> Resend Invitation</span></i>
                            </a>
                            <a _ngcontent-c2="" class="d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry">
                                <span>Delete</span>
                                <i _ngcontent-c2="" class="fas fa-trash text-white-50"><span _ngcontent-c2="" class="button-text"> Delete</span></i>
                            </a>
                        </div>    
                    </div>
                `);
            });

            //adding the minimun rater entries
            for (var i = 0; i < relationshipMin - filteredRaters.length; i++) {
                this.addNewRaterEntry(relationshipId);
            }
        } else {
            for (var i = 0; i < relationshipMin; i++) {
                this.addNewRaterEntry(relationshipId);
            }
        }
    }

    displayMinMessage(relationshipId: number) {
        //display min message if category doesnt have enought raters
        let categoryRaters = this.raters.filter((r) => {
            if (relationshipId == r.RelationshipId) return r;
        });

        let rt = this.raterTypes.findIndex(x => x.Id === relationshipId);
        let min;
        if (rt != -1) {
            min = this.raterTypes[rt].Min;
        }

        if (categoryRaters.length < min) {
            $('.categoryMinMessage span').text('You need a minimum of ' + min + ' raters for this category.');
        } else {
            $('.categoryMinMessage span').text('');
        }

        if (categoryRaters.length > 0) {
            $('.removeButtonText').text('Remove All');
        } else {
            $('.removeButtonText').text('Remove Category');
        }
    }

    addNewRaterEntry(relationshipId: number) {
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let classes = "";
        if (relationship.length != 0) {
            classes = 'd-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry';

            $('.assignCategoryEntries').append(`
                    <div class="row" data-raterId="${this.tempId}${this.counter}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;width:25%;min-width:150px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="" /></div>
                        <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="" /></div>
                        <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" type="text" value="" /></div>
                        <div class="dinamicResponsiveA" style="width:20%;">
                            <a style="display:none !important;" _ngcontent-c2="" class="d-none d-sm-inline-block btn btn-sm btn-gray">
                                <span _ngcontent-c2="">Resend Invitation</span>
                                <i _ngcontent-c2="" class="fas fa-paper-plane text-white-50"><span _ngcontent-c2="" class="button-text"> Resend Invitation</span></i>
                            </a>
                            <a _ngcontent-c2="" class="${classes}">
                                <span _ngcontent-c2="">Delete</span>
                                <i _ngcontent-c2="" class="fas fa-trash text-white-50"><span _ngcontent-c2="" class="button-text"> Delete</span></i>
                            </a>
                        </div>                        
                    </div>
                `);
            this.counter++;
        }
    }

    openAddRelationshipsModal() {
        console.log('openAddRelationshipsModal');
        this.currentSelectedRelationshipsTab = 2;
        this.isStandard = true;

        this.raterTypesStandartDataHeaders = this.createRaterTypesHeaders();
        this.raterTypesCustomDataHeaders = this.createRaterTypesHeaders();
        this.getGlobalRaterTypes();
        this.getRaterTypesByCoach();
        this.showRelationshipsModal();

        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    createRaterTypesHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);
            this.loading = false;

            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesStandartData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesStandartData);

                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
            }
        });
    }

    getRaterTypesByCoach() {
        this._CoachService.getRaterTypesByCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesByCoach', data);

            this.loading = false;
            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesCustomData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesCustomData);
                if (this.addNewRelationship) {
                    this.getRaterTypesForCoach(true);
                }
            }
        });
    }

    showRelationshipsModal() {
        $('#assignAddRelationshipsModal').modal('show');
        $('.add-rater-types-modal li').removeClass('active').eq(0).addClass('active');
    }

    hideRelationshipsModal() {
        $('.add-rater-types-modal li:first-child a').trigger('click');
        $('#assignAddRelationshipsModal').modal('hide');
    }

    onRaterTypesStandartGridReady(params) {
        this.raterTypesStandartGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterTypesCustomGridReady(params) {
        this.raterTypesCustomGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterSelectionChanged(event) {
        console.log("onRaterSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");
    }

    loadData(type: number) {
        this.currentSelectedRelationshipsTab = type;
        switch (type) {
            case 1:
                console.log('1');
                this.isStandard = false;
                //this.getRaterTypesByCoach();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesCustomGridApi);
                }, 100);
                break;

            case 2:
                console.log('2');
                this.isStandard = true;
                //this.getGlobalRaterTypes();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
                break;
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    addRelationships() {
        console.log('addRelationships');
        let standartRows = this.getSelectedRows(this.raterTypesStandartGridApi);
        let globalRows = this.getSelectedRows(this.raterTypesCustomGridApi);
        console.log('rows', standartRows);
        console.log('rows', globalRows);

        let rows = standartRows.concat(globalRows);

        let arrActiveCategories = [];
        let activeCategories = $('#purchaseAssessment .accOpen');
        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(/,/g, '');
            arrActiveCategories.push(parseInt(r));
        }

        rows.forEach((r) => {
            let categoryIndex = arrActiveCategories.findIndex(x => x === r.Id);
            if (categoryIndex == -1) {
                this.createCategoryContent(r.Id, r.Min, rows[rows.length - 1].Id);
            }
        });
        this.hideRelationshipsModal();
    }

    createCategoryContent(id, min, lastId?: number) {
        let accOpen = $('#purchaseAssessment .accOpen');
        let lastAcc;
        if (accOpen.length > 0) {
            lastAcc = accOpen[0].id;
            $("#purchaseAssessment #acc" + id).insertBefore('#purchaseAssessment #' + lastAcc);
        } else {
            $("#purchaseAssessment #acc" + id).insertAfter('.assignAcc #forFirstelement');
        }
        $('#purchaseAssessment #acc' + id).css('display', 'block');
        $('#purchaseAssessment #acc' + id).removeClass('accHide');
        $('#purchaseAssessment #acc' + id).addClass('accOpen');
        this.lastCategory = id;

        this.checkRatersAmount();
        if (id == lastId) {
            $('#purchaseAssessment #acc' + id + ' .accDiv a').trigger('click');
            this.drawData(id, min);


            setTimeout(() => {
                let accOpen = $('#purchaseAssessment .accOpen');
                console.log(accOpen);
                $('#purchaseAssessment .accOpen')[0].children[0].children[0].children[0].children[1].classList.value = "fas fa-angle-up";
            }, 200);
        }
    }

    ngOnDestroy() {
        this.close(true);
        console.log("----------------NG-ON-DESTROY----------------------");
        $(document).off('click', '#purchaseAssessment .deleteRaterEntry');
        $(document).off('focusout', '#purchaseAssessment .raterEntry');
        $(document).off('click', '#purchaseAssessment .sendEntry');
    }

    ngAfterContentInit() {
        $(document).on('click', '#purchaseAssessment .deleteRaterEntry', (e) => {
            this.showDeleteRatersConfirmationModal(e);
            this.ratertoDelete = e;
        });

        $(document).on('focusout', '#purchaseAssessment .raterEntry', (e) => {
            this.editRaterEntry(e);
        });


        $(document).on('click', '#purchaseAssessment .sendEntry', (e) => {
            $('body').css('cursor', 'wait');
            this.sendEmail(e);
        });
        this.checkRatersAmount();
    }

    editRaterEntry(e: any) {
        console.log('focusout event', e);

        let raterId = e.target.parentElement.parentElement.dataset.raterid;
        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);

        if (!result) {
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, raterPosition)) {
                        e.target.value = "";
                        //return;
                    }

                }
                this.raters[raterPosition].RecordStatus = 1;
                this.raters[raterPosition][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(raterPosition, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
            } else {
                let newRater = {
                    Email: "",
                    RaterId: 0,
                    FirstName: "",
                    LastName: "",
                    RelationshipId: relationshipId,
                    RecordStatus: 0,
                    tempIdCounter: 'tempId' + this.counter
                };
                this.raters.push(newRater);
                this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                e.target.parentElement.parentElement.dataset.raterid = 'tempId' + this.counter;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(this.raters.length, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
                this.counter++;
            }
        }
        else {
            //finding the position of the added memory entry tempIdCounter
            let raterPosition = this.raters.findIndex(
                x => x.tempIdCounter == raterId
            );
            if (raterPosition != -1) {
                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, raterPosition)) {
                        e.target.value = "";
                        //return;
                    }
                    if (this.sameClientEmail(e.target.value)) {
                        e.target.value = "";
                    }
                }
                this.raters[raterPosition][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(raterPosition, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
                //EDITING A MEMORY ENTRY
            } else {
                //TOTALLY NEW ENTRY
                console.log('relationshipId', relationshipId);

                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, -1)) {
                        e.target.value = "";
                        //return;
                    }
                    if (this.sameClientEmail(e.target.value)) {
                        e.target.value = "";
                    }
                }

                let newRater = {
                    Email: "",
                    RaterId: 0,
                    FirstName: "",
                    LastName: "",
                    RelationshipId: relationshipId,
                    RecordStatus: 0,
                    tempIdCounter: raterId
                };
                this.raters.push(newRater);
                this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(this.raters.length - 1, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
            }
        }

        console.log('raters', this.raters);
        this.displayMinMessage(relationshipId);

    }

    sendEmail(e) {
        let raterId;
        console.log(raterId);

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }
        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        let regex = /tempId/;
        let result = regex.test(raterId);

        if (!result) {

            this._RatersService.postSendEmail(this.assignmentId, [raterId]).subscribe((data: any) => {
                console.log('response_sendEmail', data);
                $('body').css('cursor', 'default');
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result == 1) {
                        this.toastr.success("Email messages sent successfully", "ELI");
                    } else if (data.result.Result == 0) {
                        this.toastr.error("We are sorry. An error happened when trying to send the email messages.", "ELI");
                    }
                    setTimeout(() => {
                        $('#assignMainAccordion').trigger("click");
                    }, 100);
                }
            });
        }

    }

    showDeleteRatersConfirmationModal(e) {
        let showModal = false;
        let relationshipId;
        let raterId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.dataset.raterid;
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid;
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('.assignAcc #acc' + relationshipId + ' .assignCategoryEntries .row');
        if (showModal) {
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (this.raters[raterPosition].Status == 1) {
                    $("#assignConfirmDeleteRatersModal").modal({ backdrop: "static" });
                    $('#assignConfirmDeleteRatersModal').modal('show');
                } else {
                    this.toastr.warning('This rater cannot be deleted since she or he has already started or completed the assessment', 'ELI');
                    setTimeout(() => {
                        $('#assignMainAccordion').trigger("click");
                    }, 10);
                }
            }
            else {
                $("#assignConfirmDeleteRatersModal").modal({ backdrop: "static" });
                $('#assignConfirmDeleteRatersModal').modal('show');
            }

        } else {
            if (inputEntries.length > relationship[0].Min) {
                this.deleteRaterEntry(e)
            } else {
                this.toastr.warning('You need a minimum of ' + relationship[0].Min + ' raters for this category', 'ELI');
                setTimeout(() => {
                    $('#assignMainAccordion').trigger("click");
                }, 10);
            }
        }
    }

    hideDeleteRatersConfirmationModal() {
        $('#assignConfirmDeleteRatersModal').modal('hide');
    }

    confirmDeleteRaters() {
        //this.inProgress = true;
        this.deleteRaterEntry(this.ratertoDelete);
    }

    deleteRaterEntry(e: any) {
        console.log('click event', e);

        let raterId;

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
        }
        console.log('relationshipId', relationshipId);

        if (!result) {
            //in database
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                this.raters[raterPosition].RecordStatus = 2;
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.deletedRaters.push(this.raters[raterPosition]);
                this.raters.splice(raterPosition, 1);
            }
        } else {
            //in memory
            let raterPosition = this.raters.findIndex(x => x.tempIdCounter === raterId);
            if (raterPosition != -1) {
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.raters.splice(raterPosition, 1);
            }
        }
        console.log('deleted', this.deletedRaters);
        //button clicked
        if (e.target.nodeName == 'A') {
            e.target.parentElement.parentElement.remove();
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            e.target.parentElement.parentElement.parentElement.remove();
        }

        //get the entries amount
        let entriesAmount = this.raters.filter((r) => {
            if (r.RelationshipId == relationshipId) return r;
        });
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('#purchaseAssessment #acc' + relationshipId + ' .assignCategoryEntries .row');
        if (entriesAmount.length < relationship[0].Min && inputEntries.length < relationship[0].Min) {
            this.addNewRaterEntry(relationshipId);
        }

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        this.hideDeleteRatersConfirmationModal();
        //this.inProgress = false;
    }

    showBulkDeleteRatersConfirmationModal(rtId) {
        this.bulkDeleteCategoryId = rtId;

        let categoryRaters = this.raters.filter((r) => {
            if (rtId == r.RelationshipId) return r;
        });

        if (categoryRaters.length > 0) {
            $('.BDMessage').text('Are you sure to want to remove all the raters for this category (the category will be removed as well)?');
        } else {
            $('.BDMessage').text('Are you sure you want to remove this category from this assessment?');
        }

        $("#assignBulkConfirmDeleteRatersModal").modal({ backdrop: "static" });
        $('#assignBulkConfirmDeleteRatersModal').modal('show');
    }

    hideBulkDeleteRatersConfirmationModal() {
        $('#assignBulkConfirmDeleteRatersModal').modal('hide');
    }

    confirmBulkDeleteRaters() {
        //this.inProgress = true;
        this.removeCatergoryContent();
    }

    removeCatergoryContent() {
        console.log('removeCategoryContent');

        this.raters = this.raters.filter((r) => {
            if (this.bulkDeleteCategoryId !== r.RelationshipId) return r;
        });
        console.log(this.raters);

        $('#purchaseAssessment #acc' + this.bulkDeleteCategoryId).css('display', 'None');
        $('#purchaseAssessment #acc' + this.bulkDeleteCategoryId).removeClass('accOpen');
        $('#purchaseAssessment #acc' + this.bulkDeleteCategoryId).addClass('accHide');
        $('#purchaseAssessment .assignAcc div').removeClass('in');
        this.checkRatersAmount();
        this.hideBulkDeleteRatersConfirmationModal();
        //this.inProgress = false;
    }

    removeDuplicates(arr) {
        let s = new Set(arr);
        let it = s.values();
        return Array.from(it);
    }

    getRaterTypesForCoach(refreshData: boolean) {
        this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesForCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let oneopen = $('.fa-angle-up').length;
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetRaterTypesForCoach', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
                this.categoryMin = _data[0].Min;

                if (refreshData) {
                    let activeCategories = $('#purchaseAssessment .accOpen');
                    console.log(activeCategories);
                    this.arrActiveCategories = [];
                    for (var i = 0; i < activeCategories.length; i++) {
                        let r = activeCategories[i].id.match(/\d/g).join(',');
                        r = r.replace(/,/g, '');
                        this.arrActiveCategories.push(parseInt(r));
                    }

                    //let selected = this.getSelectedRows(this.gridApi360);
                    //this.clientId = selected[0].ClientId;
                    //this.ratersHeaders = this.createRatersHeaders();
                    setTimeout(() => {
                        this.getRaters(0, false, oneopen);
                        if (this.addNewRelationship) {
                            $(`#rtcreateModal`).modal('hide');
                        }
                        $('body').css('cursor', 'default');
                    }, 1000);
                    //this.showRelationshipsModal();
                }
            }
        });
    }

    getRaters(assignmentId: number, refreshData: boolean, oneOpen?: number) {
        console.log('simulate getRaters');

        this.pristineRaters = this.raters;

        //from database
        if (refreshData) {

            for (var i = 0; i < this.raters.length; i++) {
                if (i == 0) {
                    $("#purchaseAssessment #acc" + this.raters[i].RelationshipId).insertAfter('.assignAcc #forFirstelement');
                } else {
                    let beforeElement = this.raters[(i - 1)].RelationshipId;
                    $("#purchaseAssessment #acc" + this.raters[i].RelationshipId).insertBefore('#purchaseAssessment #acc' + beforeElement);
                }

                $('#purchaseAssessment #acc' + this.raters[i].RelationshipId).css('display', 'block');
                $('#purchaseAssessment #acc' + this.raters[i].RelationshipId).removeClass('accHide');
                $('#purchaseAssessment #acc' + this.raters[i].RelationshipId).addClass('accOpen');
                //$('#relationships').val(r.RelationshipId);
            }
        } else {
            //this.arrActiveCategories.forEach((r) => {
            for (var i = 0; i < this.arrActiveCategories.length; i++) {
                if (i == 0) {
                    $("#purchaseAssessment #acc" + this.arrActiveCategories[i]).insertAfter('.assignAcc #forFirstelement');
                } else {
                    let beforeElement = this.arrActiveCategories[(i - 1)];
                    $("#purchaseAssessment #acc" + this.arrActiveCategories[i]).insertAfter('#purchaseAssessment #acc' + beforeElement);
                }
                $('#purchaseAssessment #acc' + this.arrActiveCategories[i]).css('display', 'block');
                $('#purchaseAssessment #acc' + this.arrActiveCategories[i]).removeClass('accHide');
                $('#purchaseAssessment #acc' + this.arrActiveCategories[i]).addClass('accOpen');
                //$('#relationships').val(r); 
            }
        }

        this.checkRatersAmount();

        if (!this.executed) {
            this.executed = true;
            let pristineCategories = $('#purchaseAssessment .accOpen');
            console.log(pristineCategories);

            for (var i = 0; i < $('#purchaseAssessment .accOpen').length; i++) {
                let r = pristineCategories[i].id.match(/\d/g).join(',');
                r = r.replace(/,/g, '');
                this.pristineCategories.push(parseInt(r));
            }
        }

        if (oneOpen > 0) {
            //open the first catefory
            let firstElement = $('#purchaseAssessment .accOpen a');
            firstElement[0].click();
            firstElement[0].children[0].children[1].classList.value = 'fas fa-angle-up';
        }

        this.loading = false;
        //this.sizeToFit(this.raterGridApi);
    }


    showConfirmCloseRatersModal(closeAssign:boolean) {
        let activeCategories = $('#purchaseAssessment .accOpen');
        console.log(activeCategories);


        if (this.raters.length > 0 || activeCategories.length > 0) {
            $("#assignConfirmCloseRatersModal").modal({ backdrop: "static" });
            $('#assignConfirmCloseRatersModal').modal('show');
        } else {
            this.close(closeAssign); 
            if (!this._Globals.assignAssessmentsForImportClients) {
                this.removeFilters(this.currentgridApi);
            }
        }
    }

    hideConfirmCloseRatersModal() {
        $('#assignConfirmCloseRatersModal').modal('hide');
    }

    arraysAreEqual(ary1, ary2) {
        console.log(JSON.stringify(ary1));
        console.log(JSON.stringify(ary2));
        return (JSON.stringify(ary1) == JSON.stringify(ary2));
    }

    onRaterTypesRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            console.log(data);
            if (!this.isStandard) {
                this.openModal('Edit', data['Id'], data['Name']); //, data['Min']);
            }
        }
    }

    openModal(action: string, raterId: number, raterName: string) { //, raterMin: number) {
        if (!this.isStandard) {
            this.action = action;
            this.currentRaterId = raterId;
            this.rname = raterName;

            console.log($(`#rtcreateModal`));
            $(`#rtcreateModal`).modal({ backdrop: "static" });
            $(`#rtcreateModal`).modal('show');
            //$(`.${this.modalPrefix} #rtcreateEditModal`).modal({ backdrop: "static" });
            //$(`.${this.modalPrefix} #rtcreateEditModal`).modal('show');
        }
    }

    deleteRaterType() {
        this._AdminService.postDeleteRaterType(this.currentRaterId).subscribe((data: any) => {
            console.log('response_DeleteRaterType', data.result.Result);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case 1:
                        this.getRaterTypesByCoach();
                        $(`#rtcreateModal`).modal('hide');
                        $(`#cDeleteModal`).modal('hide');
                        this.toastr.success("Relationship deleted successfully", "ELI");
                        break;
                    case 0:
                        this.toastr.error("We are sorry.  An error happened while trying to delete the relationship", "ELI");
                        break;
                    case -1:
                        this.toastr.warning("This relationship cannot be deleted since it is being used in assessment assignments", "ELI");
                        break;
                }
            }
        });
    }

    //save rater type
    saveRaterType() {
        let raterType = new RaterTypeDto;
        raterType.Id = this.currentRaterId;
        raterType.Name = this.rname;
        raterType.Min = 3;
        raterType.IsGlobal = false;

        if (raterType.Name === "") {
            this.toastr.warning("The field name can not be empty.", "ELI");
            return;
        }

        //if (raterType.Min === null || raterType.Min < 0) {
        //    this._toastr.warning("Invalid entry for Min field.", "ELI");
        //    return;
        //}

        this.postSaveRaterType(raterType);
    }

    postSaveRaterType(raterType: RaterTypeDto) {
        $('body').css('cursor', 'wait');
        this._AdminService.postSaveRaterType(raterType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                console.log('data', data);
                //this.getGlobalRaterTypes();
                this.addNewRelationship = true;
                this.getRaterTypesByCoach();
            } else {
                $('body').css('cursor', 'default');
            }
        })
    }


    /*Confirmation Delete*/

    openConfirmationModal() {
        $(`#cDeleteModal`).modal({ backdrop: "static" });
        $(`#cDeleteModal`).modal('show');
    }

    closeModalConfirmation() {
        $(`#cDeleteModal`).modal('hide');
    }

    removeFilters(gridApi: any) {
        let columns = ['Email', 'FirstName', 'LastName'];

        columns.forEach((column) => {
            var filterComponent = gridApi.getFilterInstance(column);
            filterComponent.setModel(null);
            gridApi.onFilterChanged();
        });

    }

}
